var _excluded = ["click", "area", "find"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (x) {
    return "%".concat(x.charCodeAt(0).toString(16).toUpperCase());
  });
};

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return decodeURIComponent(components.join(''));
  } catch (err) {// Do nothing
  }

  if (components.length === 1) {
    return components;
  }

  split = split || 1; // Split the array in 2 parts

  var left = components.slice(0, split);
  var right = components.slice(split);
  return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher);

    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join('');
      tokens = input.match(singleMatcher);
    }

    return input;
  }
}

function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    '%FE%FF': "\uFFFD\uFFFD",
    '%FF%FE': "\uFFFD\uFFFD"
  };
  var match = multiMatcher.exec(input);

  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);

      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }

    match = multiMatcher.exec(input);
  } // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else


  replaceMap['%C2'] = "\uFFFD";
  var entries = Object.keys(replaceMap);

  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
  }

  return input;
}

var decodeUriComponent = function decodeUriComponent(encodedURI) {
  if (typeof encodedURI !== 'string') {
    throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + _typeof(encodedURI) + '`');
  }

  try {
    encodedURI = encodedURI.replace(/\+/g, ' '); // Try the built in decoder first

    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }

  if (separator === '') {
    return [string];
  }

  var separatorIndex = string.indexOf(separator);

  if (separatorIndex === -1) {
    return [string];
  }

  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
};

var filterObj = function filterObj(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];

    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }

  return ret;
};

var queryString = createCommonjsModule(function (module, exports) {
  var isNullOrUndefined = function isNullOrUndefined(value) {
    return value === null || value === undefined;
  };

  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case 'index':
        return function (key) {
          return function (result, value) {
            var index = result.length;

            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[', index, ']'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')]);
          };
        };

      case 'bracket':
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [[encode(key, options), '[]'].join('')]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '[]=', encode(value, options)].join('')]);
          };
        };

      case 'comma':
      case 'separator':
        return function (key) {
          return function (result, value) {
            if (value === null || value === undefined || value.length === 0) {
              return result;
            }

            if (result.length === 0) {
              return [[encode(key, options), '=', encode(value, options)].join('')];
            }

            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        };

      default:
        return function (key) {
          return function (result, value) {
            if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') {
              return result;
            }

            if (value === null) {
              return [].concat(_toConsumableArray(result), [encode(key, options)]);
            }

            return [].concat(_toConsumableArray(result), [[encode(key, options), '=', encode(value, options)].join('')]);
          };
        };
    }
  }

  function parserForArrayFormat(options) {
    var result;

    switch (options.arrayFormat) {
      case 'index':
        return function (key, value, accumulator) {
          result = /\[(\d*)\]$/.exec(key);
          key = key.replace(/\[\d*\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }

          accumulator[key][result[1]] = value;
        };

      case 'bracket':
        return function (key, value, accumulator) {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, '');

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };

      case 'comma':
      case 'separator':
        return function (key, value, accumulator) {
          var isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
          var isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function (item) {
            return decode(item, options);
          }) : value === null ? value : decode(value, options);
          accumulator[key] = newValue;
        };

      default:
        return function (key, value, accumulator) {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }

  function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) {
      throw new TypeError('arrayFormatSeparator must be single character string');
    }
  }

  function encode(value, options) {
    if (options.encode) {
      return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    }

    return value;
  }

  function decode(value, options) {
    if (options.decode) {
      return decodeUriComponent(value);
    }

    return value;
  }

  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }

    if (_typeof(input) === 'object') {
      return keysSorter(Object.keys(input)).sort(function (a, b) {
        return Number(a) - Number(b);
      }).map(function (key) {
        return input[key];
      });
    }

    return input;
  }

  function removeHash(input) {
    var hashStart = input.indexOf('#');

    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }

    return input;
  }

  function getHash(url) {
    var hash = '';
    var hashStart = url.indexOf('#');

    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }

    return hash;
  }

  function extract(input) {
    input = removeHash(input);
    var queryStart = input.indexOf('?');

    if (queryStart === -1) {
      return '';
    }

    return input.slice(queryStart + 1);
  }

  function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') {
      value = Number(value);
    } else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
      value = value.toLowerCase() === 'true';
    }

    return value;
  }

  function parse(query, options) {
    options = Object.assign({
      decode: true,
      sort: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ',',
      parseNumbers: false,
      parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = parserForArrayFormat(options); // Create an object with no prototype

    var ret = Object.create(null);

    if (typeof query !== 'string') {
      return ret;
    }

    query = query.trim().replace(/^[?#&]/, '');

    if (!query) {
      return ret;
    }

    var _iterator = _createForOfIteratorHelper(query.split('&')),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var param = _step.value;

        if (param === '') {
          continue;
        }

        var _splitOnFirst = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '='),
            _splitOnFirst2 = _slicedToArray(_splitOnFirst, 2),
            _key = _splitOnFirst2[0],
            _value = _splitOnFirst2[1]; // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters


        _value = _value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? _value : decode(_value, options);
        formatter(decode(_key, options), _value, ret);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    for (var _i = 0, _Object$keys = Object.keys(ret); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      var value = ret[key];

      if (_typeof(value) === 'object' && value !== null) {
        for (var _i2 = 0, _Object$keys2 = Object.keys(value); _i2 < _Object$keys2.length; _i2++) {
          var k = _Object$keys2[_i2];
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }

    if (options.sort === false) {
      return ret;
    }

    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function (result, key) {
      var value = ret[key];

      if (Boolean(value) && _typeof(value) === 'object' && !Array.isArray(value)) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }

      return result;
    }, Object.create(null));
  }

  exports.extract = extract;
  exports.parse = parse;

  exports.stringify = function (object, options) {
    if (!object) {
      return '';
    }

    options = Object.assign({
      encode: true,
      strict: true,
      arrayFormat: 'none',
      arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);

    var shouldFilter = function shouldFilter(key) {
      return options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    };

    var formatter = encoderForArrayFormat(options);
    var objectCopy = {};

    for (var _i3 = 0, _Object$keys3 = Object.keys(object); _i3 < _Object$keys3.length; _i3++) {
      var key = _Object$keys3[_i3];

      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }

    var keys = Object.keys(objectCopy);

    if (options.sort !== false) {
      keys.sort(options.sort);
    }

    return keys.map(function (key) {
      var value = object[key];

      if (value === undefined) {
        return '';
      }

      if (value === null) {
        return encode(key, options);
      }

      if (Array.isArray(value)) {
        return value.reduce(formatter(key), []).join('&');
      }

      return encode(key, options) + '=' + encode(value, options);
    }).filter(function (x) {
      return x.length > 0;
    }).join('&');
  };

  exports.parseUrl = function (url, options) {
    options = Object.assign({
      decode: true
    }, options);

    var _splitOnFirst3 = splitOnFirst(url, '#'),
        _splitOnFirst4 = _slicedToArray(_splitOnFirst3, 2),
        url_ = _splitOnFirst4[0],
        hash = _splitOnFirst4[1];

    return Object.assign({
      url: url_.split('?')[0] || '',
      query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
      fragmentIdentifier: decode(hash, options)
    } : {});
  };

  exports.stringifyUrl = function (object, options) {
    options = Object.assign({
      encode: true,
      strict: true
    }, options);
    var url = removeHash(object.url).split('?')[0] || '';
    var queryFromUrl = exports.extract(object.url);
    var parsedQueryFromUrl = exports.parse(queryFromUrl, {
      sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = exports.stringify(query, options);

    if (queryString) {
      queryString = "?".concat(queryString);
    }

    var hash = getHash(object.url);

    if (object.fragmentIdentifier) {
      hash = "#".concat(encode(object.fragmentIdentifier, options));
    }

    return "".concat(url).concat(queryString).concat(hash);
  };

  exports.pick = function (input, filter, options) {
    options = Object.assign({
      parseFragmentIdentifier: true
    }, options);

    var _exports$parseUrl = exports.parseUrl(input, options),
        url = _exports$parseUrl.url,
        query = _exports$parseUrl.query,
        fragmentIdentifier = _exports$parseUrl.fragmentIdentifier;

    return exports.stringifyUrl({
      url: url,
      query: filterObj(query, filter),
      fragmentIdentifier: fragmentIdentifier
    }, options);
  };

  exports.exclude = function (input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function (key) {
      return !filter.includes(key);
    } : function (key, value) {
      return !filter(key, value);
    };
    return exports.pick(input, exclusionFilter, options);
  };
});
queryString.extract;
queryString.parse;
queryString.stringify;
queryString.parseUrl;
queryString.stringifyUrl;
queryString.pick;
queryString.exclude;
var e = [],
    t = [];

function n(n, r) {
  if (n && "undefined" != typeof document) {
    var a,
        s = !0 === r.prepend ? "prepend" : "append",
        d = !0 === r.singleTag,
        i = "string" == typeof r.container ? document.querySelector(r.container) : document.getElementsByTagName("head")[0];

    if (d) {
      var u = e.indexOf(i);
      -1 === u && (u = e.push(i) - 1, t[u] = {}), a = t[u] && t[u][s] ? t[u][s] : t[u][s] = c();
    } else a = c();

    65279 === n.charCodeAt(0) && (n = n.substring(1)), a.styleSheet ? a.styleSheet.cssText += n : a.appendChild(document.createTextNode(n));
  }

  function c() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), r.attributes) for (var t = Object.keys(r.attributes), n = 0; n < t.length; n++) {
      e.setAttribute(t[n], r.attributes[t[n]]);
    }
    var a = "prepend" === s ? "afterbegin" : "beforeend";
    return i.insertAdjacentElement(a, e), e;
  }
}

var css = ".dom-inspector {\n    position: fixed;\n    pointer-events: none;\n}\n\n.dom-inspector>div {\n\tposition: absolute;\n}\n\n.dom-inspector .tips {\n\tbackground-color: #333740;\n\tfont-size: 0;\n\tline-height: 18px;\n\tpadding: 3px 10px;\n\tposition: fixed;\n\tborder-radius: 4px;\n\tdisplay: none;\n}\n\n.dom-inspector .tips .triangle {\n\twidth: 0;\n\theight: 0;\n\tposition: absolute;\n\tborder-top: 8px solid #333740;\n\tborder-right: 8px solid transparent;\n\tborder-bottom: 8px solid transparent;\n\tborder-left: 8px solid transparent;\n\tleft: 10px;\n\ttop: 186px;\n}\n\n.dom-inspector .tips.reverse .triangle {\n\tborder-top: 8px solid transparent;\n\tborder-right: 8px solid transparent;\n\tborder-bottom: 8px solid #333740;\n\tborder-left: 8px solid transparent;\n\tleft: 10px;\n\ttop: -16px;\n}\n\n.dom-inspector .tips>div {\n\tfont-size: 12px;\n\tcolor: white;\n\tfont-family: Consolas, Menlo, Monaco, Courier, monospace;\n\toverflow: auto;\n}\n\n.dom-inspector-theme-default {\n\n}\n\n.dom-inspector-theme-default .margin {\n\tbackground-color: rgba(255, 81, 81, 0.75);\n}\n\n.dom-inspector-theme-default .border {\n\tbackground-color: rgba(255, 81, 81, 0.75);\n}\n\n.dom-inspector-theme-default .padding {\n\tbackground-color: rgba(81, 101, 255, 0.75);\n}\n\n.dom-inspector-theme-default .content {\n\tbackground-color: rgba(81, 101, 255, 0.75);\n}\n";
n(css, {});

function mixin(target, source) {
  var targetCopy = target;
  Object.keys(source).forEach(function (item) {
    if ({}.hasOwnProperty.call(source, item)) {
      targetCopy[item] = source[item];
    }
  });
  return targetCopy;
}

function throttle(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var timeout;
  var elapsed;
  var lastRunTime = Date.now(); // 上次运行时间

  return function none() {
    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var self = this;
    clearTimeout(timeout);
    elapsed = Date.now() - lastRunTime;

    function later() {
      lastRunTime = Date.now();
      timeout = null;
      func.apply(self, args);
    }

    if (elapsed > wait) {
      later();
    } else {
      timeout = setTimeout(later, wait - elapsed);
    }
  };
}

function isNull(obj) {
  return Object.prototype.toString.call(obj).replace(/\[object[\s]/, '').replace(']', '').toLowerCase() === 'null';
}

function copyToClipboard(str) {
  var el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}
/* eslint-disable max-len */


function isDOM() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _typeof(obj) === 'object' && obj.nodeType === 1 && _typeof(obj.style) === 'object' && _typeof(obj.ownerDocument) === 'object';
}

function $(selector, parent) {
  if (!parent) return document.querySelector(selector);
  if (isDOM(parent)) return parent.querySelector(selector);
  return document.querySelector(selector);
}

function addRule(selector, cssObj) {
  Object.keys(cssObj).forEach(function (item) {
    selector.style[item] = cssObj[item];
  });
}

function findPos(ele) {
  var computedStyle = getComputedStyle(ele);
  var x = ele.getBoundingClientRect().left - parseFloat(computedStyle['margin-left']);
  var y = ele.getBoundingClientRect().top - parseFloat(computedStyle['margin-top']);
  var el = ele.parent;

  while (el) {
    computedStyle = getComputedStyle(el);
    x += el.frameElement.getBoundingClientRect().left - parseFloat(computedStyle['margin-left']);
    y += el.frameElement.getBoundingClientRect().top - parseFloat(computedStyle['margin-top']);
    el = el.parent;
  }

  return {
    top: y,
    left: x
  };
}
/**
 * @param  { Dom Element }
 * @return { Object }
 */


function _getElementInfo(ele) {
  var result = {};
  var features = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'z-index'];
  var computedStyle = getComputedStyle(ele);
  features.forEach(function (item) {
    result[item] = parseFloat(computedStyle[item]) || 0;
  });
  mixin(result, {
    width: ele.offsetWidth - result['border-left-width'] - result['border-right-width'] - result['padding-left'] - result['padding-right'],
    height: ele.offsetHeight - result['border-top-width'] - result['border-bottom-width'] - result['padding-top'] - result['padding-bottom']
  });
  mixin(result, findPos(ele));
  return result;
}

function getMaxZIndex() {
  return _toConsumableArray(document.all).reduce(function (r, e) {
    return Math.max(r, +window.getComputedStyle(e).zIndex || 0);
  }, 0);
}

function isParent(obj, parentObj) {
  while (obj !== undefined && obj !== null && obj.tagName.toUpperCase() !== 'BODY') {
    if (obj == parentObj) return true;
    obj = obj.parentNode;
  }

  return false;
}

function getCoords(elem) {
  if (elem) {
    var box = elem.getBoundingClientRect();
    var _document = document,
        body = _document.body;
    var docEl = document.documentElement;
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;
    return {
      top: Math.round(top),
      left: Math.round(left)
    };
  }

  return {
    top: 0,
    left: 0
  };
}

var hashcode = function hashcode(str) {
  var strFixEmpty = str ? str : '';
  var arr = strFixEmpty.split('');
  return arr.reduce(function (hashCode, currentVal) {
    return hashCode = currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode;
  }, 0);
};

var contain = function contain(arr) {
  var arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr2.some(function (i) {
    var result = arr.findIndex(function (a) {
      return i.indexOf(a) !== -1;
    });
    return result > -1;
  });
};

var closest = function closest(targetElement, selector) {
  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      var el = undefined;

      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);

      return null;
    };
  }

  if (Array.isArray(selector)) {
    var result = null;
    selector.some(function (s) {
      var cls = targetElement.closest(s);

      if (cls !== null) {
        result = cls;
        return true;
      }

      return false;
    });
    return result;
  }

  return targetElement.closest(selector);
};

var getClassname = function getClassname(element) {
  if (!element) {
    return '';
  }

  var className = '';
  var classList = element.classList || [];
  classList.forEach(function (item) {
    className += ".".concat(item);
  });
  return className;
};

var getTargetAttr = function getTargetAttr(target, attr) {
  if (!target) {
    return null;
  }

  var TargetAttr = target.getAttribute && target.getAttribute(attr);

  if (TargetAttr) {
    return TargetAttr;
  }

  return getTargetAttr(target.parentNode, attr);
};
/** 获取该元素或父类元素含有指定参数的元素 */


var getElementByParam = function getElementByParam(target, param) {
  if (!target) {
    return null;
  }

  var TargetAttr = target["".concat(param)];

  if (TargetAttr) {
    return target;
  }

  return getElementByParam(target.parentNode, param);
};
/** 获取该元素或父类元素tag 为制定tag 的元素 */


var getElementByTag = function getElementByTag(target, tag) {
  if (!target || !target.tagName) {
    return null;
  }

  var isTargetTag = target.tagName.toLowerCase() === tag;

  if (isTargetTag) {
    return target;
  }

  return getElementByTag(target.parentNode, tag);
};

function getVisibleEventAttr() {
  // 设置隐藏属性和改变可见属性的事件的名称
  var hidden;
  var visibilityChange;

  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  return {
    hidden: hidden,
    visibilityChange: visibilityChange
  };
}

function isHTMLElement(obj) {
  return _typeof(obj) === 'object' && obj.nodeType === 1 && _typeof(obj.style) === 'object' && _typeof(obj.ownerDocument) === 'object';
}

var formattext = function formattext(text) {
  return text.replace(/[\r\n]/g, '').replace(/\s/g, '');
};

var _window = window,
    document$1 = _window.document;

var getTarget = function getTarget(queryDom) {
  return document$1.getElementById(queryDom) || document$1.getElementsByName(queryDom)[0] || document$1.querySelector(queryDom);
};

var readElement = function readElement(el, parent) {
  var element = el ? el : document$1.body;

  if (!(element instanceof HTMLElement) && !(element instanceof SVGElement)) {
    console.error('element is not trackable');
    return {};
  }

  if (element instanceof SVGElement) {
    // svg/path todo:拆分逻辑
    var closestCtx = element.closest('.omui-button') || (element.closest('.omui-icon') !== null ? element.closest('.omui-icon').parentNode : element.parentNode);
    element = closestCtx;
  }

  var result = {
    eid: '',
    type: '',
    top: getCoords(element).top,
    // 在文档中的位置，不会随页面滚动而变化
    left: getCoords(element).left,
    viewLeft: element.getBoundingClientRect().left,
    // 在视口的位置，会随页面滚动而变化
    viewTop: element.getBoundingClientRect().top,
    text: element.innerText,
    parentInfo: ''
  }; // construct data info of the element

  var _element = element,
      id = _element.id,
      name = _element.name;
  var tag = element.tagName.toLowerCase();
  var type = element.type ? element.type.toLowerCase() : '';
  var className = getClassname(element);
  var queryDom = '';

  if (tag === 'body' || tag === 'html') {
    result.queryDom = tag;
    result.findway = tag;
  } // location by id


  if (id && document$1.getElementById(id) === element) {
    var regExp = new RegExp('^[a-zA-Z]+');
    /** 当不为parent定位直接返回id, 否则使用完整路径标识符 */

    if (!parent) result.queryDom = id;
    /* 如果为parent定位，或者设置为完整结果时候，返回tag#id */
    else if (regExp.test(id)) {
      result.queryDom = "".concat(tag, "#").concat(id);
    }
    result.findway = 'document.getElementById()';
  } // location by name


  if (!result.queryDom && name && document$1.getElementsByName(name)[0] === element) {
    result.queryDom = name;
    result.findway = 'document.getElementsByName()';
  } // location by class


  if (!result.queryDom && className && document$1.querySelector(tag + className) === element) {
    result.queryDom = tag + className;
    result.findway = 'document.querySelector()';
  } // for radio


  if (type === 'radio') {
    var _element2 = element,
        value = _element2.value;

    var _queryDom = "".concat(tag, "[value='").concat(value, "']");

    if (name) {
      _queryDom = "".concat(tag, "[name='").concat(name, "']");
    }

    if (document$1.querySelector(_queryDom) === element) {
      result.queryDom = _queryDom;
      result.findway = 'document.querySelector()';
    }
  } // location by mixed


  if (!result.queryDom) {
    queryDom = tag;
    queryDom = className ? queryDom + className : queryDom;
    queryDom = name ? "".concat(queryDom, "[name='").concat(name, "']") : queryDom;

    if (getTarget(queryDom) === element) {
      result.queryDom = queryDom;
      result.findway = 'document.querySelector()';
    }
  } // location by order


  if (!result.queryDom) {
    queryDom = tag;
    queryDom = className ? queryDom + className : queryDom;
    var elements = document$1.querySelectorAll(queryDom);

    if (elements && elements.length > 0) {
      var index = null;

      for (var i = 0; i < elements.length; i++) {
        if (element === elements[i]) {
          index = i + 1;
          break;
        }
      }

      if (index) {
        queryDom = "".concat(queryDom, ":nth-child(").concat(index, ")");

        if (document$1.querySelector(queryDom) === element) {
          result.queryDom = queryDom;
          result.findway = 'document.querySelector()';
        }
      }
    }
  } // location by parent


  if (!result.queryDom) {
    if (!element.parentNode) {
      return;
    }

    var parentQueryResult = readElement(element.parentNode, true);
    var parentqueryDom = parentQueryResult ? parentQueryResult.queryDom : '';

    if (!parentqueryDom) {
      return {
        eid: '',
        type: 'NO_LOCATION'
      };
    }

    var targetQuery = tag;

    if (className) {
      targetQuery += className;
    }

    queryDom = "".concat(parentqueryDom, ">").concat(targetQuery);
    var queryElements = document$1.querySelectorAll(queryDom);

    if (queryElements.length > 1) {
      queryDom = null;
      var _index = null;

      for (var j = 0; j < element.parentNode.children.length; j++) {
        if (element.parentNode.children[j] === element) {
          _index = j + 1;
          break;
        }
      }

      if (_index >= 1) {
        queryDom = "".concat(parentqueryDom, ">").concat(targetQuery, ":nth-child(").concat(_index, ")");
        var queryTarget = document$1.querySelector(queryDom);

        if (queryTarget != element) {
          queryDom = null;
        }
      }
    }

    result.queryDom = queryDom;
    result.findway = 'document.querySelector()';
    result.parentInfo = parentQueryResult;
  }

  result.id = id;
  result.name = name;
  result.className = className.split('.').filter(function (c) {
    return c !== '';
  });
  result.tag = tag;
  result.type = type;
  result.eid = hashcode(result.queryDom);
  return result;
};

var defaultEid = 'dt-eid';

var findDomClassname = function findDomClassname() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var queryDom = arguments.length > 1 ? arguments[1] : undefined;
  var spl = arguments.length > 2 ? arguments[2] : undefined;

  if (className.length === 0) {
    return />/.test(queryDom) ? queryDom.split('>')[0] : queryDom;
  }

  var domcls = className.filter(function (c) {
    return c.indexOf(spl) !== -1;
  }); // 用spl作为自定义classname的识别符

  if (domcls.length === 0) {
    return className[0] + (className[1] ? "--".concat(className[1]) : ''); // 先暂时取前两个classname作为dom识别
  }

  return domcls[0].split(spl)[0];
};

var findDomName = function findDomName(el) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var suffix = arguments.length > 2 ? arguments[2] : undefined;
  var node = el;

  if (selector !== '') {
    node = el.querySelector(selector);
  }

  var _readElement = readElement(node || el),
      text = _readElement.text,
      className = _readElement.className,
      queryDom = _readElement.queryDom; // 避免这里innertext取到过深子节点，造成text很长准确无法识别定位


  if (text !== '' && node && node.childElementCount < 2) {
    return formattext(text);
  }

  return findDomClassname(className, queryDom, suffix);
};

var getContext = function getContext(ctx, suffix, specfind) {
  if (!ctx) return '';
  var result = ctx.getAttribute('name') || ctx.getAttribute('id') || '';

  if (result !== '') {
    return result;
  }

  result = findDomName(ctx, specfind, suffix);
  if (result === 'body') result = '';
  return result;
};

function trackClickDom($target, config) {
  var params = null;
  var keyEid = config.keyEid; // click

  var eid = getTargetAttr($target, keyEid || defaultEid);
  var remark = getTargetAttr($target, 'dt-remark');

  if (eid !== null) {
    // 声明式上报，需要元素定义dteid属性
    params = {
      eid: eid,
      remark: remark
    };
  } else {
    // 自动上报
    var result = readElement($target); // 参数为空时，默认计算鼠标点击到的最后一个HTML元素。

    var id = result.id,
        name = result.name,
        queryDom = result.queryDom,
        tag = result.tag,
        _result$text = result.text,
        text = _result$text === void 0 ? '' : _result$text,
        parentInfo = result.parentInfo;
    var clickConf = config.click,
        dialogSelector = config.dialogSelector,
        formSelector = config.formSelector,
        tabSelector = config.tabSelector,
        tableSelector = config.tableSelector,
        classSuffix = config.classSuffix,
        _config$find = config.find,
        find = _config$find === void 0 ? {} : _config$find;
    var className = result.className;

    if (className && className.length === 0) {
      className = parentInfo.className;
    }

    var dom = id || name || findDomClassname(className, queryDom, classSuffix);

    if (tag === 'button' || tag === 'a' || contain(clickConf, className)) {
      var dialogCtx = closest($target, dialogSelector);
      var formCtx = closest($target, formSelector);
      var tabCtx = closest($target, tabSelector);
      var tableCtx = closest($target, tableSelector);
      params = {
        text: formattext(text),
        queryDom: queryDom,
        dom: dom,
        dialog: getContext(dialogCtx, classSuffix, find[dialogSelector]),
        tab: getContext(tabCtx, classSuffix, find[tabSelector]),
        form: getContext(formCtx, classSuffix, find[formSelector]),
        table: getContext(tableCtx, classSuffix, find[tableSelector]),
        remark: remark
      };
    }
  }

  return params;
}

function trackClickDomHasEvent($target, config) {
  try {
    var keyEid = config.keyEid,
        eventClickName = config.eventClickName;
    var params = null; // click

    var eid = getTargetAttr($target, keyEid || defaultEid);
    var remark = getTargetAttr($target, 'dt-remark');

    if (eid !== null) {
      // 声明式上报，需要元素定义dteid属性
      params = {
        eid: eid,
        remark: remark
      };
    } else {
      // 自动上报
      // button, a, hasAttr 都用父类的 queryDom
      var $targetElement = getElementByTag($target, 'a') || getElementByTag($target, 'button') || getElementByParam($target, eventClickName || 'onclick'); // 如果找到满足的条件，则上报

      var matchCondition = false;

      if ($targetElement) {
        matchCondition = true;
      } else {
        $targetElement = $target;
      }

      var result = readElement($targetElement); // 参数为空时，默认计算鼠标点击到的最后一个HTML元素。

      var id = result.id,
          name = result.name,
          queryDom = result.queryDom,
          _result$text2 = result.text,
          text = _result$text2 === void 0 ? '' : _result$text2,
          parentInfo = result.parentInfo;
      var clickConf = config.click,
          dialogSelector = config.dialogSelector,
          formSelector = config.formSelector,
          tabSelector = config.tabSelector,
          tableSelector = config.tableSelector,
          classSuffix = config.classSuffix,
          _config$find2 = config.find,
          find = _config$find2 === void 0 ? {} : _config$find2;
      var className = result.className;

      if (className && className.length === 0) {
        className = parentInfo.className;
      }

      var dom = id || name || findDomClassname(className, queryDom, classSuffix);

      if (matchCondition || contain(clickConf, className)) {
        var dialogCtx = closest($targetElement, dialogSelector);
        var formCtx = closest($targetElement, formSelector);
        var tabCtx = closest($targetElement, tabSelector);
        var tableCtx = closest($targetElement, tableSelector);
        params = {
          text: formattext(text),
          queryDom: queryDom,
          dom: dom,
          dialog: getContext(dialogCtx, classSuffix, find[dialogSelector]),
          tab: getContext(tabCtx, classSuffix, find[tabSelector]),
          form: getContext(formCtx, classSuffix, find[formSelector]),
          table: getContext(tableCtx, classSuffix, find[tableSelector]),
          remark: remark
        };
      }
    }

    return params;
  } catch (error) {
    console.error('trackClickDom', error);
  }
}

function trackExposeDom(el, _ref) {
  var classSuffix = _ref.classSuffix,
      area = _ref.area,
      find = _ref.find;
  var areaId = el.getAttribute('dt-areaid') || el.getAttribute('name') || el.getAttribute('id') || '';
  var Whatarea = readElement(el);
  var eid = Whatarea.eid,
      top = Whatarea.top;
  var params = {
    eid: eid,
    areaTop: parseInt(top, 10)
  };

  if (areaId !== '') {
    return _objectSpread({
      areaId: areaId
    }, params);
  }

  var findel = area.filter(function (conf) {
    return getClassname(el).indexOf(conf) !== -1;
  });
  var areaselector = '';

  if (findel.length !== 0) {
    areaselector = find[findel[0]] || '';
  } // let dom;
  // if (areaselector !== '') {
  //   dom = findDomName(el, areaselector, classSuffix);
  // } else {
  //   dom = findDomName(Whatarea.className, Whatarea.queryDom, classSuffix);
  // }


  return _objectSpread({
    areaId: findDomName(el, areaselector, classSuffix)
  }, params);
}

var sep = 'DomInspector: ';
var proxy = ['log', 'warn', 'error'];
var exportObj = {};
proxy.forEach(function (item) {
  exportObj[item] = function funcName() {
    return console[item].call(this, sep + (arguments.length <= 0 ? undefined : arguments[0]), (arguments.length <= 1 ? undefined : arguments[1]) || '');
  };
});

var DomInspector = /*#__PURE__*/function () {
  function DomInspector() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DomInspector);

    this.doc = window.document;
    this.root = options.root ? isDOM(options.root) ? options.root : $(options.root) : $('body');

    if (isNull(this.root)) {
      exportObj.warn('Root element is null. Auto select body as root');
      this.root = $('body');
    }

    this.trackConfig = options.trackConfig;
    this.areaConf = options.trackConfig.area;
    this.theme = options.theme || 'dom-inspector-theme-default';
    this.exclude = this.formatExcludeOption(options.exclude || []);
    this.viewArea = [];
    this.overlay = {};
    this.overlayId = '';
    this.target = '';
    this.destroyed = false;
    this.maxZIndex = options.maxZIndex || getMaxZIndex() + 1;
    this.cachedTarget = '';
    this.throttleOnMove = throttle(this.onMove.bind(this), 300);
    this.copyInfo = throttle(this.onKeydownCopy.bind(this), 300);
    this.funcNameTrackClickDom = options.useTrackClickDomHasEvent ? trackClickDomHasEvent : trackClickDom;
    this.init();
  }

  _createClass(DomInspector, [{
    key: "enable",
    value: function enable() {
      if (this.destroyed) return exportObj.warn('Inspector instance has been destroyed! Please redeclare it.');
      this.overlay.parent.style.display = 'block';
      this.root.addEventListener('mousemove', this.throttleOnMove);
      this.root.addEventListener('keydown', this.copyInfo);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.root.removeEventListener('mousemove', this.throttleOnMove);
      this.root.addEventListener('mousemove', this.copyInfo);
      clearInterval(this.hightlightTimer);
    }
  }, {
    key: "disable",
    value: function disable() {
      this.overlay.parent.style.display = 'none';
      this.overlay.parent.style.width = 0;
      this.overlay.parent.style.height = 0;
      this.target = null;
      this.root.removeEventListener('mousemove', this.throttleOnMove);
      clearInterval(this.hightlightTimer);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed = true;
      this.disable();
      this.overlay = {};
    }
  }, {
    key: "getCommonParams",
    value: function getCommonParams() {
      return {
        pathname: /^#/.test(location.hash) ? location.hash.slice(1) : location.pathname
      };
    }
  }, {
    key: "trackViewParams",
    value: function trackViewParams(el) {
      var _this = this;

      var params = null;
      this.viewArea.forEach(function (area) {
        if (area.isEqualNode(el)) {
          params = trackExposeDom(el, _this.trackConfig);
        }
      });
      return params;
    }
  }, {
    key: "getElementInfo",
    value: function getElementInfo(ele) {
      if (!isDOM(ele) && !this.target) return exportObj.warn('Target element is not found. Warning function name:%c getElementInfo', 'color: #ff5151');
      return _getElementInfo(ele || this.target);
    }
  }, {
    key: "init",
    value: function init() {
      this.overlayId = "dom-inspector-".concat(Date.now());
      var parent = this.createElement('div', {
        id: this.overlayId,
        "class": "dom-inspector ".concat(this.theme),
        style: "z-index: ".concat(this.maxZIndex)
      });
      this.overlay = {
        parent: parent,
        content: this.createSurroundEle(parent, 'content'),
        paddingTop: this.createSurroundEle(parent, 'padding padding-top'),
        paddingRight: this.createSurroundEle(parent, 'padding padding-right'),
        paddingBottom: this.createSurroundEle(parent, 'padding padding-bottom'),
        paddingLeft: this.createSurroundEle(parent, 'padding padding-left'),
        // eslint-disable-next-line max-len
        tips: this.createSurroundEle(parent, 'tips', '<div class="eventtype"></div><div class="channel"></div><div class="pathname"></div><div class="clickparams"><div class="eid"></div><div class="text"></div><div class="dom"></div><div class="dialog"></div><div class="table"></div><div class="tab"></div><div class="form"></div><div class="remark"></div></div><div class="areaparams"><div class="areaId"></div></div>')
      };
      this.root.appendChild(parent);
      this.highlightTrack();
    }
  }, {
    key: "highlightTrack",
    value: function highlightTrack() {
      var _this2 = this;

      if (this.areaConf.length === 0) return;
      this.hightlightTimer = setInterval(function () {
        _this2.viewArea = document.querySelectorAll(_this2.areaConf.join(','));

        if (_this2.viewArea.length > 0) {
          // 高光圈出各个曝光统计区域
          _this2.viewArea.forEach(function (dom) {
            dom.style.border = 'thick solid yellow';
          });
        }
      }, 5000);
    }
  }, {
    key: "createElement",
    value: function createElement(tag, attr, content) {
      var ele = this.doc.createElement(tag);
      Object.keys(attr).forEach(function (item) {
        ele.setAttribute(item, attr[item]);
      });
      if (content) ele.innerHTML = content;
      return ele;
    }
  }, {
    key: "createSurroundEle",
    value: function createSurroundEle(parent, className, content) {
      var ele = this.createElement('div', {
        "class": className
      }, content);
      parent.appendChild(ele);
      return ele;
    }
  }, {
    key: "onKeydownCopy",
    value: function onKeydownCopy(e) {
      if (e.keyCode === 13 && this.overlay.tips.style.display === 'block') {
        copyToClipboard(this.overlay.tips.innerText);
      }
    }
  }, {
    key: "overlayAddRule",
    value: function overlayAddRule(margin, content, padding, info, trackparams) {
      addRule(this.overlay.parent, {
        width: "".concat(margin.width, "px"),
        height: "".concat(margin.height, "px"),
        top: "".concat(info.top, "px"),
        left: "".concat(info.left, "px")
      });
      addRule(this.overlay.content, {
        width: "".concat(content.width, "px"),
        height: "".concat(content.height, "px"),
        top: "".concat(info['margin-top'] + info['border-top-width'] + info['padding-top'], "px"),
        left: "".concat(info['margin-left'] + info['border-left-width'] + info['padding-left'], "px")
      });
      addRule(this.overlay.paddingTop, {
        width: "".concat(padding.width, "px"),
        height: "".concat(info['padding-top'], "px"),
        top: "".concat(info['margin-top'] + info['border-top-width'], "px"),
        left: "".concat(info['margin-left'] + info['border-left-width'], "px")
      });
      addRule(this.overlay.paddingRight, {
        width: "".concat(info['padding-right'], "px"),
        height: "".concat(padding.height - info['padding-top'], "px"),
        top: "".concat(info['padding-top'] + info['margin-top'] + info['border-top-width'], "px"),
        right: "".concat(info['margin-right'] + info['border-right-width'], "px")
      });
      addRule(this.overlay.paddingBottom, {
        width: "".concat(padding.width - info['padding-right'], "px"),
        height: "".concat(info['padding-bottom'], "px"),
        bottom: "".concat(info['margin-bottom'] + info['border-bottom-width'], "px"),
        right: "".concat(info['padding-right'] + info['margin-right'] + info['border-right-width'], "px")
      });
      addRule(this.overlay.paddingLeft, {
        width: "".concat(info['padding-left'], "px"),
        height: "".concat(padding.height - info['padding-top'] - info['padding-bottom'], "px"),
        top: "".concat(info['padding-top'] + info['margin-top'] + info['border-top-width'], "px"),
        left: "".concat(info['margin-left'] + info['border-left-width'], "px")
      });
      this.adjustTipdom(trackparams, margin, info);
    }
  }, {
    key: "adjustTipdom",
    value: function adjustTipdom(trackparams, margin, info) {
      var _trackparams$eid = trackparams.eid,
          eid = _trackparams$eid === void 0 ? '' : _trackparams$eid,
          _trackparams$areaId = trackparams.areaId,
          areaId = _trackparams$areaId === void 0 ? '' : _trackparams$areaId,
          _trackparams$text = trackparams.text,
          text = _trackparams$text === void 0 ? '' : _trackparams$text,
          _trackparams$dom = trackparams.dom,
          dom = _trackparams$dom === void 0 ? '' : _trackparams$dom,
          _trackparams$dialog = trackparams.dialog,
          dialog = _trackparams$dialog === void 0 ? '' : _trackparams$dialog,
          _trackparams$tab = trackparams.tab,
          tab = _trackparams$tab === void 0 ? '' : _trackparams$tab,
          _trackparams$form = trackparams.form,
          form = _trackparams$form === void 0 ? '' : _trackparams$form,
          _trackparams$table = trackparams.table,
          table = _trackparams$table === void 0 ? '' : _trackparams$table,
          _trackparams$remark = trackparams.remark,
          remark = _trackparams$remark === void 0 ? '' : _trackparams$remark,
          pathname = trackparams.pathname;
      $('.eventtype', this.overlay.eventtype).innerHTML = "event: ".concat(areaId !== '' ? 'show_area' : 'click'); // $('.channel', this.overlay.channel).innerHTML = `om_channel: ${om_channel}`;

      $('.pathname', this.overlay.pathname).innerHTML = "pathname: ".concat(pathname);
      var tip = this.overlay.tips;
      var tipheight = 257;

      if (areaId !== '') {
        $('.clickparams', tip).style.display = 'none';
        $('.areaparams', tip).style.display = 'block';
        $('.areaId', tip).innerHTML = "areaId: ".concat(areaId);
        tipheight = 80;
      } else {
        $('.eid', tip).innerHTML = "eid: ".concat(eid);
        $('.text', tip).innerHTML = "text: ".concat(text);
        $('.dom', tip).innerHTML = "dom: ".concat(dom);
        $('.dialog', tip).innerHTML = "dialog: ".concat(dialog);
        $('.tab', tip).innerHTML = "tab: ".concat(tab);
        $('.form', tip).innerHTML = "form: ".concat(form);
        $('.table', tip).innerHTML = "table: ".concat(table);
        $('.remark', tip).innerHTML = "remark: ".concat(remark);
        $('.areaparams', tip).style.display = 'none';
        $('.clickparams', tip).style.display = 'block';
      }

      var tipsTop = 0;

      if (info.top >= tipheight + 8) {
        tip.classList.remove('reverse');
        tipsTop = info.top - (tipheight - 70) - 8;
      } else {
        tip.classList.add('reverse');
        tipsTop = margin.height + info.top + 8;
      }

      addRule(tip, {
        top: "".concat(tipsTop, "px"),
        left: "".concat(info.left, "px"),
        display: 'block'
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e) {
      try {
        // 是否在排除列表里
        this.exclude.forEach(function (el) {
          if (el.isEqualNode(e.target) || isParent(e.target, el)) return;
        });
        this.target = e.target;
        if (this.target === this.cachedTarget) return null;
        var trackparams = this.funcNameTrackClickDom(this.target, this.trackConfig);

        if (trackparams === null && this.viewArea.length > 0) {
          // 没有落到点击事件元素上，再看下是否落在曝光区域元素上
          trackparams = this.trackViewParams(this.target);
        }

        if (trackparams === null) {
          return null;
        }

        var commonparams = this.getCommonParams();
        trackparams = Object.assign(trackparams, commonparams);
        this.cachedTarget = this.target;

        var elementInfo = _getElementInfo(e.target);

        var content = {
          width: elementInfo.width,
          height: elementInfo.height
        };
        var padding = {
          width: elementInfo['padding-left'] + content.width + elementInfo['padding-right'],
          height: elementInfo['padding-top'] + content.height + elementInfo['padding-bottom']
        };
        var border = {
          width: elementInfo['border-left-width'] + padding.width + elementInfo['border-right-width'],
          height: elementInfo['border-top-width'] + padding.height + elementInfo['border-bottom-width']
        };
        var margin = {
          width: elementInfo['margin-left'] + border.width + elementInfo['margin-right'],
          height: elementInfo['margin-top'] + border.height + elementInfo['margin-bottom']
        };
        this.overlayAddRule(margin, content, padding, elementInfo, trackparams);
      } catch (error) {
        console.log('onMove error', error);
      }
    }
  }, {
    key: "formatExcludeOption",
    value: function formatExcludeOption() {
      var excludeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var result = [];
      excludeArray.forEach(function (item) {
        if (typeof item === 'string') return result.push($(item));
        if (isDOM(item)) return result.push(item);
      });
      return result;
    }
  }]);

  return DomInspector;
}();
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */


(function () {
  // Exit early if we're not running in a browser.
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return;
  } // Exit early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.


  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }

    return;
  }
  /**
   * Returns the embedding frame element, if any.
   * @param {!Document} doc
   * @return {!Element}
   */


  function getFrameElement(doc) {
    try {
      return doc.defaultView && doc.defaultView.frameElement || null;
    } catch (e) {
      // Ignore the error.
      return null;
    }
  }
  /**
   * A local reference to the root document.
   */


  var document = function (startDoc) {
    var doc = startDoc;
    var frame = getFrameElement(doc);

    while (frame) {
      doc = frame.ownerDocument;
      frame = getFrameElement(doc);
    }

    return doc;
  }(window.document);
  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observing a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */


  var registry = [];
  /**
   * The signal updater for cross-origin intersection. When not null, it means
   * that the polyfill is configured to work in a cross-origin mode.
   * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  var crossOriginUpdater = null;
  /**
   * The current cross-origin intersection. Only used in the cross-origin mode.
   * @type {DOMRect|ClientRect}
   */

  var crossOriginRect = null;
  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */

  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = ensureDOMRect(entry.rootBounds);
    this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
    this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
    this.isIntersecting = !!entry.intersectionRect; // Calculates the intersection ratio.

    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height; // Sets intersection ratio.

    if (targetArea) {
      // Round the intersection ratio to avoid floating point math issues:
      // https://github.com/w3c/IntersectionObserver/issues/324
      this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }
  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */


  function IntersectionObserver(callback, opt_options) {
    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1 && options.root.nodeType != 9) {
      throw new Error('root must be a Document or Element');
    } // Binds and throttles `this._checkForIntersections`.


    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT); // Private properties.

    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin); // Public properties.

    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
    /** @private @const {!Array<!Document>} */

    this._monitoringDocuments = [];
    /** @private @const {!Array<function()>} */

    this._monitoringUnsubscribes = [];
  }
  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */


  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */

  IntersectionObserver.prototype.POLL_INTERVAL = null;
  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */

  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
  /**
   * Sets up the polyfill in the cross-origin mode. The result is the
   * updater function that accepts two arguments: `boundingClientRect` and
   * `intersectionRect` - just as these fields would be available to the
   * parent via `IntersectionObserverEntry`. This function should be called
   * each time the iframe receives intersection information from the parent
   * window, e.g. via messaging.
   * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
   */

  IntersectionObserver._setupCrossOriginUpdater = function () {
    if (!crossOriginUpdater) {
      /**
       * @param {DOMRect|ClientRect} boundingClientRect
       * @param {DOMRect|ClientRect} intersectionRect
       */
      crossOriginUpdater = function crossOriginUpdater(boundingClientRect, intersectionRect) {
        if (!boundingClientRect || !intersectionRect) {
          crossOriginRect = getEmptyRect();
        } else {
          crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
        }

        registry.forEach(function (observer) {
          observer._checkForIntersections();
        });
      };
    }

    return crossOriginUpdater;
  };
  /**
   * Resets the cross-origin mode.
   */


  IntersectionObserver._resetCrossOriginUpdater = function () {
    crossOriginUpdater = null;
    crossOriginRect = null;
  };
  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();

    this._observationTargets.push({
      element: target,
      entry: null
    });

    this._monitorIntersections(target.ownerDocument);

    this._checkForIntersections();
  };
  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */


  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {
      return item.element != target;
    });

    this._unmonitorIntersections(target.ownerDocument);

    if (this._observationTargets.length == 0) {
      this._unregisterInstance();
    }
  };
  /**
   * Stops observing all target elements for intersection changes.
   */


  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];

    this._unmonitorAllIntersections();

    this._unregisterInstance();
  };
  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */


  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();

    this._queuedEntries = [];
    return records;
  };
  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */


  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];
    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }

      return t !== a[i - 1];
    });
  };
  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */


  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);

      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }

      return {
        value: parseFloat(parts[1]),
        unit: parts[2]
      };
    }); // Handles shorthand.

    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];
    return margins;
  };
  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibility state is visible.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._monitorIntersections = function (doc) {
    var win = doc.defaultView;

    if (!win) {
      // Already destroyed.
      return;
    }

    if (this._monitoringDocuments.indexOf(doc) != -1) {
      // Already monitoring.
      return;
    } // Private state for monitoring.


    var callback = this._checkForIntersections;
    var monitoringInterval = null;
    var domObserver = null; // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.

    if (this.POLL_INTERVAL) {
      monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
    } else {
      addEvent(win, 'resize', callback, true);
      addEvent(doc, 'scroll', callback, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
        domObserver = new win.MutationObserver(callback);
        domObserver.observe(doc, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    this._monitoringDocuments.push(doc);

    this._monitoringUnsubscribes.push(function () {
      // Get the window object again. When a friendly iframe is destroyed, it
      // will be null.
      var win = doc.defaultView;

      if (win) {
        if (monitoringInterval) {
          win.clearInterval(monitoringInterval);
        }

        removeEvent(win, 'resize', callback, true);
      }

      removeEvent(doc, 'scroll', callback, true);

      if (domObserver) {
        domObserver.disconnect();
      }
    }); // Also monitor the parent.


    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._monitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorIntersections = function (doc) {
    var index = this._monitoringDocuments.indexOf(doc);

    if (index == -1) {
      return;
    }

    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document; // Check if any dependent targets are still remaining.

    var hasDependentTargets = this._observationTargets.some(function (item) {
      var itemDoc = item.element.ownerDocument; // Target is in this context.

      if (itemDoc == doc) {
        return true;
      } // Target is nested in this context.


      while (itemDoc && itemDoc != rootDoc) {
        var frame = getFrameElement(itemDoc);
        itemDoc = frame && frame.ownerDocument;

        if (itemDoc == doc) {
          return true;
        }
      }

      return false;
    });

    if (hasDependentTargets) {
      return;
    } // Unsubscribe.


    var unsubscribe = this._monitoringUnsubscribes[index];

    this._monitoringDocuments.splice(index, 1);

    this._monitoringUnsubscribes.splice(index, 1);

    unsubscribe(); // Also unmonitor the parent.

    if (doc != rootDoc) {
      var frame = getFrameElement(doc);

      if (frame) {
        this._unmonitorIntersections(frame.ownerDocument);
      }
    }
  };
  /**
   * Stops polling for intersection changes.
   * @param {!Document} doc
   * @private
   */


  IntersectionObserver.prototype._unmonitorAllIntersections = function () {
    var unsubscribes = this._monitoringUnsubscribes.slice(0);

    this._monitoringDocuments.length = 0;
    this._monitoringUnsubscribes.length = 0;

    for (var i = 0; i < unsubscribes.length; i++) {
      unsubscribes[i]();
    }
  };
  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */


  IntersectionObserver.prototype._checkForIntersections = function () {
    if (!this.root && crossOriginUpdater && !crossOriginRect) {
      // Cross origin monitoring, but no initial data available yet.
      return;
    }

    var rootIsInDom = this._rootIsInDom();

    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);

      var rootContainsTarget = this._rootContainsTarget(target);

      var oldEntry = item.entry;

      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, targetRect, rootRect);

      var rootBounds = null;

      if (!this._rootContainsTarget(target)) {
        rootBounds = getEmptyRect();
      } else if (!crossOriginUpdater || this.root) {
        rootBounds = rootRect;
      }

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootBounds,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };
  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} targetRect The bounding rect of the target.
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */


  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, targetRect, rootRect) {
    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot && parent) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {}; // If the parent isn't displayed, an intersection can't happen.

      if (parentComputedStyle.display == 'none') return null;

      if (parent == this.root || parent.nodeType ==
      /* DOCUMENT */
      9) {
        atRoot = true;

        if (parent == this.root || parent == document) {
          if (crossOriginUpdater && !this.root) {
            if (!crossOriginRect || crossOriginRect.width == 0 && crossOriginRect.height == 0) {
              // A 0-size cross-origin intersection means no-intersection.
              parent = null;
              parentRect = null;
              intersectionRect = null;
            } else {
              parentRect = crossOriginRect;
            }
          } else {
            parentRect = rootRect;
          }
        } else {
          // Check if there's a frame that can be navigated to.
          var frame = getParentNode(parent);
          var frameRect = frame && getBoundingClientRect(frame);

          var frameIntersect = frame && this._computeTargetAndRootIntersection(frame, frameRect, rootRect);

          if (frameRect && frameIntersect) {
            parent = frame;
            parentRect = convertFromParentRect(frameRect, frameIntersect);
          } else {
            parent = null;
            intersectionRect = null;
          }
        }
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        var doc = parent.ownerDocument;

        if (parent != doc.body && parent != doc.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      } // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.


      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);
      }

      if (!intersectionRect) break;
      parent = parent && getParentNode(parent);
    }

    return intersectionRect;
  };
  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {ClientRect} The expanded root rect.
   * @private
   */


  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;

    if (this.root && !isDoc(this.root)) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var doc = isDoc(this.root) ? this.root : document;
      var html = doc.documentElement;
      var body = doc.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }

    return this._expandRectByRootMargin(rootRect);
  };
  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {DOMRect|ClientRect} rect The rect object to expand.
   * @return {ClientRect} The expanded rect.
   * @private
   */


  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });

    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;
    return newRect;
  };
  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */


  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {
    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1; // Ignore unchanged ratios

    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i]; // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.

      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };
  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */


  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };
  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */


  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    var rootDoc = this.root && (this.root.ownerDocument || this.root) || document;
    return containsDeep(rootDoc, target) && (!this.root || rootDoc == target.ownerDocument);
  };
  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */


  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };
  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */


  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };
  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */


  function now() {
    return window.performance && performance.now && performance.now();
  }
  /**
   * Throttles a function and delays its execution, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */


  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }
  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */


  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }
  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */


  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }
  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object|?ClientRect} The intersection rect or undefined if no
   *     intersection is found.
   */


  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;
    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    } || null;
  }
  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
   */


  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {// Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect(); // Older IE

    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }

    return rect;
  }
  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {ClientRect} The empty rect.
   */


  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  /**
   * Ensure that the result has all of the necessary fields of the DOMRect.
   * Specifically this ensures that `x` and `y` fields are set.
   *
   * @param {?DOMRect|?ClientRect} rect
   * @return {?DOMRect}
   */


  function ensureDOMRect(rect) {
    // A `DOMRect` object has `x` and `y` fields.
    if (!rect || 'x' in rect) {
      return rect;
    } // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
    // for internally calculated Rect objects. For the purposes of
    // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
    // for these fields.


    return {
      top: rect.top,
      y: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      x: rect.left,
      right: rect.right,
      width: rect.width,
      height: rect.height
    };
  }
  /**
   * Inverts the intersection and bounding rect from the parent (frame) BCR to
   * the local BCR space.
   * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
   * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
   * @return {ClientRect} The local root bounding rect for the parent's children.
   */


  function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
    var top = parentIntersectionRect.top - parentBoundingRect.top;
    var left = parentIntersectionRect.left - parentBoundingRect.left;
    return {
      top: top,
      left: left,
      height: parentIntersectionRect.height,
      width: parentIntersectionRect.width,
      bottom: top + parentIntersectionRect.height,
      right: left + parentIntersectionRect.width
    };
  }
  /**
   * Checks to see if a parent element contains a child element (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */


  function containsDeep(parent, child) {
    var node = child;

    while (node) {
      if (node == parent) return true;
      node = getParentNode(node);
    }

    return false;
  }
  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */


  function getParentNode(node) {
    var parent = node.parentNode;

    if (node.nodeType ==
    /* DOCUMENT */
    9 && node != document) {
      // If this node is a document node, look for the embedding frame.
      return getFrameElement(node);
    } // If the parent has element that is assigned through shadow root slot


    if (parent && parent.assignedSlot) {
      parent = parent.assignedSlot.parentNode;
    }

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }

    return parent;
  }
  /**
   * Returns true if `node` is a Document.
   * @param {!Node} node
   * @returns {boolean}
   */


  function isDoc(node) {
    return node && node.nodeType === 9;
  } // Exposes the constructors globally.


  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})();
/* eslint-disable no-underscore-dangle */
// 延迟时间，节流作用


IntersectionObserver.prototype.THROTTLE_TIMEOUT = 300;

var Exposure = /*#__PURE__*/function () {
  function Exposure(_ref2) {
    var _ref2$threshold = _ref2.threshold,
        threshold = _ref2$threshold === void 0 ? 0.5 : _ref2$threshold,
        doReport = _ref2.doReport,
        config = _ref2.config;

    _classCallCheck(this, Exposure);

    this.time = 500; // 延迟上报时间

    this.dataList = [];
    this.threshold = threshold;
    this._observer = null;
    this._timer = null;
    this.doReport = doReport;
    this.init(config);
  } // 初始化


  _createClass(Exposure, [{
    key: "init",
    value: function init(config) {
      var _this3 = this;

      var self = this;
      this._observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 进入视图触发
            try {
              self._timer && clearTimeout(self._timer); // 清除定时器

              var target = entry.target;

              if (entry.intersectionRatio > _this3.threshold) {
                var _trackExposeDom = trackExposeDom(target, config),
                    eid = _trackExposeDom.eid,
                    areaId = _trackExposeDom.areaId,
                    areaTop = _trackExposeDom.areaTop;

                var remark = target.getAttribute('dt-remark');

                if (!self.dataList.includes(eid)) {
                  // 避免重复统计曝光
                  self.send({
                    areaId: areaId,
                    areaTop: areaTop,
                    remark: remark
                  });
                  self.dataList.push(eid);
                }

                self._observer.unobserve(entry.target);
              }
            } catch (err) {
              console.log(err);
            }
          }
        });
      }, {
        root: null,
        rootMargin: '64px',
        threshold: this.threshold // 目标dom出现在视图的比例 0 - 1

      });
    } // 添加至观察列表

  }, {
    key: "add",
    value: function add(entry) {
      this._observer && this._observer.observe(entry);
    } // 触发上报数据

  }, {
    key: "send",
    value: function send(data) {
      this.doReport(data);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this._observer.disconnect();
    }
  }]);

  return Exposure;
}();

var beacon_web_min = createCommonjsModule(function (module, exports) {
  /*! For license information please see beacon_web.min.js.LICENSE.txt */
  !function (e, t) {
    module.exports = t();
  }(window, function () {
    return function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) {
          n.d(r, o, function (t) {
            return e[t];
          }.bind(null, o));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e["default"];
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 40);
    }([function (e, t, n) {
      n.d(t, "i", function () {
        return r;
      }), n.d(t, "j", function () {
        return o;
      }), n.d(t, "l", function () {
        return i;
      }), n.d(t, "o", function () {
        return a;
      }), n.d(t, "g", function () {
        return s;
      }), n.d(t, "k", function () {
        return u;
      }), n.d(t, "h", function () {
        return c;
      }), n.d(t, "m", function () {
        return f;
      }), n.d(t, "n", function () {
        return l;
      }), n.d(t, "d", function () {
        return d;
      }), n.d(t, "f", function () {
        return p;
      }), n.d(t, "e", function () {
        return h;
      }), n.d(t, "a", function () {
        return v;
      }), n.d(t, "c", function () {
        return m;
      }), n.d(t, "b", function () {
        return y;
      });
      var r = "https://otheve.beacon.qq.com/analytics/v2_upload",
          o = "A99",
          i = "A100",
          a = "__BEACON_",
          s = "__BEACON_deviceId",
          u = "last_report_time",
          c = "direct_log_id",
          f = "normal_log_id",
          l = "sending_event_ids",
          d = "beacon_config",
          p = "beacon_config_request_time",
          h = "https://oth.str.beacon.qq.com/trpc.beacon.configserver.BeaconConfigService/QueryConfig",
          v = "00400014144",
          m = "6478159937",
          y = "https://h.trace.qq.com/kv";
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return o;
      }), n.d(t, "b", function () {
        return i;
      }), n.d(t, "d", function () {
        return a;
      }), n.d(t, "e", function () {
        return s;
      }), n.d(t, "c", function () {
        return u;
      });

      var r = n(0),
          o = function () {
        function e() {
          var e = this;
          this.emit = function (t, n) {
            if (e) {
              var r,
                  o = e.__EventsList[t];

              if (null == o ? void 0 : o.length) {
                o = o.slice();

                for (var i = 0; i < o.length; i++) {
                  r = o[i];

                  try {
                    var a = r.callback.apply(e, [n]);
                    if (1 === r.type && e.remove(t, r.callback), !1 === a) break;
                  } catch (e) {
                    throw e;
                  }
                }
              }

              return e;
            }
          }, this.__EventsList = {};
        }

        return e.prototype.indexOf = function (e, t) {
          for (var n = 0; n < e.length; n++) {
            if (e[n].callback === t) return n;
          }

          return -1;
        }, e.prototype.on = function (e, t, n) {
          if (void 0 === n && (n = 0), this) {
            var r = this.__EventsList[e];

            if (r || (r = this.__EventsList[e] = []), -1 === this.indexOf(r, t)) {
              var o = {
                name: e,
                type: n || 0,
                callback: t
              };
              return r.push(o), this;
            }

            return this;
          }
        }, e.prototype.one = function (e, t) {
          this.on(e, t, 1);
        }, e.prototype.remove = function (e, t) {
          if (this) {
            var n = this.__EventsList[e];
            if (!n) return null;

            if (!t) {
              try {
                delete this.__EventsList[e];
              } catch (e) {}

              return null;
            }

            if (n.length) {
              var r = this.indexOf(n, t);
              n.splice(r, 1);
            }

            return this;
          }
        }, e;
      }();

      function i(e, t) {
        if (!e) throw t instanceof Error ? t : new Error(t);
      }

      function a(e, t) {
        for (var n = {}, r = 0, o = Object.keys(e); r < o.length; r++) {
          var i = o[r],
              a = e[i];
          if ("string" == typeof a) n[s(i)] = s(a);else {
            if (t) throw new Error("value mast be string  !!!!");
            n[s(String(i))] = s(String(a));
          }
        }

        return n;
      }

      function s(e) {
        if ("string" != typeof e) return e;

        try {
          return e.replace(new RegExp("\\|", "g"), "%7C").replace(new RegExp("\\&", "g"), "%26").replace(new RegExp("\\=", "g"), "%3D").replace(new RegExp("\\+", "g"), "%2B");
        } catch (e) {
          return "";
        }
      }

      function u(e) {
        return String(e[r.j]) + String(e[r.l]);
      }
    }, function (e, t, n) {
      var r = n(11),
          o = Object.prototype.toString;

      function i(e) {
        return "[object Array]" === o.call(e);
      }

      function a(e) {
        return void 0 === e;
      }

      function s(e) {
        return null !== e && "object" == _typeof(e);
      }

      function u(e) {
        if ("[object Object]" !== o.call(e)) return !1;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      }

      function c(e) {
        return "[object Function]" === o.call(e);
      }

      function f(e, t) {
        if (null != e) if ("object" != _typeof(e) && (e = [e]), i(e)) for (var n = 0, r = e.length; n < r; n++) {
          t.call(null, e[n], n, e);
        } else for (var o in e) {
          Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
        }
      }

      e.exports = {
        isArray: i,
        isArrayBuffer: function isArrayBuffer(e) {
          return "[object ArrayBuffer]" === o.call(e);
        },
        isBuffer: function isBuffer(e) {
          return null !== e && !a(e) && null !== e.constructor && !a(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
        },
        isFormData: function isFormData(e) {
          return "undefined" != typeof FormData && e instanceof FormData;
        },
        isArrayBufferView: function isArrayBufferView(e) {
          return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
        },
        isString: function isString(e) {
          return "string" == typeof e;
        },
        isNumber: function isNumber(e) {
          return "number" == typeof e;
        },
        isObject: s,
        isPlainObject: u,
        isUndefined: a,
        isDate: function isDate(e) {
          return "[object Date]" === o.call(e);
        },
        isFile: function isFile(e) {
          return "[object File]" === o.call(e);
        },
        isBlob: function isBlob(e) {
          return "[object Blob]" === o.call(e);
        },
        isFunction: c,
        isStream: function isStream(e) {
          return s(e) && c(e.pipe);
        },
        isURLSearchParams: function isURLSearchParams(e) {
          return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
        },
        isStandardBrowserEnv: function isStandardBrowserEnv() {
          return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
        },
        forEach: f,
        merge: function e() {
          var t = {};

          function n(n, r) {
            u(t[r]) && u(n) ? t[r] = e(t[r], n) : u(n) ? t[r] = e({}, n) : i(n) ? t[r] = n.slice() : t[r] = n;
          }

          for (var r = 0, o = arguments.length; r < o; r++) {
            f(arguments[r], n);
          }

          return t;
        },
        extend: function extend(e, t, n) {
          return f(t, function (t, o) {
            e[o] = n && "function" == typeof t ? r(t, n) : t;
          }), e;
        },
        trim: function trim(e) {
          return e.replace(/^\s*/, "").replace(/\s*$/, "");
        },
        stripBOM: function stripBOM(e) {
          return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
        }
      };
    }, function (e, t, n) {
      (function (t) {
        e.exports = function e(t, n, r) {
          function o(a, s) {
            if (!n[a]) {
              if (!t[a]) {
                if (i) return i(a, !0);
                var u = new Error("Cannot find module '" + a + "'");
                throw u.code = "MODULE_NOT_FOUND", u;
              }

              var c = n[a] = {
                exports: {}
              };
              t[a][0].call(c.exports, function (e) {
                var n = t[a][1][e];
                return o(n || e);
              }, c, c.exports, e, t, n, r);
            }

            return n[a].exports;
          }

          for (var i = !1, a = 0; a < r.length; a++) {
            o(r[a]);
          }

          return o;
        }({
          1: [function (e, n, r) {
            (function (e) {
              var t,
                  r,
                  o = e.MutationObserver || e.WebKitMutationObserver;

              if (o) {
                var i = 0,
                    a = new o(f),
                    s = e.document.createTextNode("");
                a.observe(s, {
                  characterData: !0
                }), t = function t() {
                  s.data = i = ++i % 2;
                };
              } else if (e.setImmediate || void 0 === e.MessageChannel) t = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
                var t = e.document.createElement("script");
                t.onreadystatechange = function () {
                  f(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                }, e.document.documentElement.appendChild(t);
              } : function () {
                setTimeout(f, 0);
              };else {
                var u = new e.MessageChannel();
                u.port1.onmessage = f, t = function t() {
                  u.port2.postMessage(0);
                };
              }

              var c = [];

              function f() {
                var e, t;
                r = !0;

                for (var n = c.length; n;) {
                  for (t = c, c = [], e = -1; ++e < n;) {
                    t[e]();
                  }

                  n = c.length;
                }

                r = !1;
              }

              n.exports = function (e) {
                1 !== c.push(e) || r || t();
              };
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {}],
          2: [function (e, t, n) {
            var r = e(1);

            function o() {}

            var i = {},
                a = ["REJECTED"],
                s = ["FULFILLED"],
                u = ["PENDING"];

            function c(e) {
              if ("function" != typeof e) throw new TypeError("resolver must be a function");
              this.state = u, this.queue = [], this.outcome = void 0, e !== o && p(this, e);
            }

            function f(e, t, n) {
              this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof n && (this.onRejected = n, this.callRejected = this.otherCallRejected);
            }

            function l(e, t, n) {
              r(function () {
                var r;

                try {
                  r = t(n);
                } catch (t) {
                  return i.reject(e, t);
                }

                r === e ? i.reject(e, new TypeError("Cannot resolve promise with itself")) : i.resolve(e, r);
              });
            }

            function d(e) {
              var t = e && e.then;
              if (e && ("object" == _typeof(e) || "function" == typeof e) && "function" == typeof t) return function () {
                t.apply(e, arguments);
              };
            }

            function p(e, t) {
              var n = !1;

              function r(t) {
                n || (n = !0, i.reject(e, t));
              }

              function o(t) {
                n || (n = !0, i.resolve(e, t));
              }

              var a = h(function () {
                t(o, r);
              });
              "error" === a.status && r(a.value);
            }

            function h(e, t) {
              var n = {};

              try {
                n.value = e(t), n.status = "success";
              } catch (e) {
                n.status = "error", n.value = e;
              }

              return n;
            }

            t.exports = c, c.prototype["catch"] = function (e) {
              return this.then(null, e);
            }, c.prototype.then = function (e, t) {
              if ("function" != typeof e && this.state === s || "function" != typeof t && this.state === a) return this;
              var n = new this.constructor(o);
              return this.state !== u ? l(n, this.state === s ? e : t, this.outcome) : this.queue.push(new f(n, e, t)), n;
            }, f.prototype.callFulfilled = function (e) {
              i.resolve(this.promise, e);
            }, f.prototype.otherCallFulfilled = function (e) {
              l(this.promise, this.onFulfilled, e);
            }, f.prototype.callRejected = function (e) {
              i.reject(this.promise, e);
            }, f.prototype.otherCallRejected = function (e) {
              l(this.promise, this.onRejected, e);
            }, i.resolve = function (e, t) {
              var n = h(d, t);
              if ("error" === n.status) return i.reject(e, n.value);
              var r = n.value;
              if (r) p(e, r);else {
                e.state = s, e.outcome = t;

                for (var o = -1, a = e.queue.length; ++o < a;) {
                  e.queue[o].callFulfilled(t);
                }
              }
              return e;
            }, i.reject = function (e, t) {
              e.state = a, e.outcome = t;

              for (var n = -1, r = e.queue.length; ++n < r;) {
                e.queue[n].callRejected(t);
              }

              return e;
            }, c.resolve = function (e) {
              return e instanceof this ? e : i.resolve(new this(o), e);
            }, c.reject = function (e) {
              var t = new this(o);
              return i.reject(t, e);
            }, c.all = function (e) {
              var t = this;
              if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
              var n = e.length,
                  r = !1;
              if (!n) return this.resolve([]);

              for (var a = new Array(n), s = 0, u = -1, c = new this(o); ++u < n;) {
                f(e[u], u);
              }

              return c;

              function f(e, o) {
                t.resolve(e).then(function (e) {
                  a[o] = e, ++s !== n || r || (r = !0, i.resolve(c, a));
                }, function (e) {
                  r || (r = !0, i.reject(c, e));
                });
              }
            }, c.race = function (e) {
              var t = this;
              if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
              var n = e.length,
                  r = !1;
              if (!n) return this.resolve([]);

              for (var a, s = -1, u = new this(o); ++s < n;) {
                a = e[s], t.resolve(a).then(function (e) {
                  r || (r = !0, i.resolve(u, e));
                }, function (e) {
                  r || (r = !0, i.reject(u, e));
                });
              }

              return u;
            };
          }, {
            1: 1
          }],
          3: [function (e, n, r) {
            (function (t) {
              "function" != typeof t.Promise && (t.Promise = e(2));
            }).call(this, void 0 !== t ? t : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
          }, {
            2: 2
          }],
          4: [function (e, t, n) {
            var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
                o = function () {
              try {
                if ("undefined" != typeof indexedDB) return indexedDB;
                if ("undefined" != typeof webkitIndexedDB) return webkitIndexedDB;
                if ("undefined" != typeof mozIndexedDB) return mozIndexedDB;
                if ("undefined" != typeof OIndexedDB) return OIndexedDB;
                if ("undefined" != typeof msIndexedDB) return msIndexedDB;
              } catch (e) {
                return;
              }
            }();

            function i(e, t) {
              e = e || [], t = t || {};

              try {
                return new Blob(e, t);
              } catch (o) {
                if ("TypeError" !== o.name) throw o;

                for (var n = new ("undefined" != typeof BlobBuilder ? BlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : WebKitBlobBuilder)(), r = 0; r < e.length; r += 1) {
                  n.append(e[r]);
                }

                return n.getBlob(t.type);
              }
            }

            "undefined" == typeof Promise && e(3);
            var a = Promise;

            function s(e, t) {
              t && e.then(function (e) {
                t(null, e);
              }, function (e) {
                t(e);
              });
            }

            function u(e, t, n) {
              "function" == typeof t && e.then(t), "function" == typeof n && e["catch"](n);
            }

            function c(e) {
              return "string" != typeof e && (e = String(e)), e;
            }

            function f() {
              if (arguments.length && "function" == typeof arguments[arguments.length - 1]) return arguments[arguments.length - 1];
            }

            var l = void 0,
                d = {},
                p = Object.prototype.toString;

            function h(e) {
              return "boolean" == typeof l ? a.resolve(l) : function (e) {
                return new a(function (t) {
                  var n = e.transaction("local-forage-detect-blob-support", "readwrite"),
                      r = i([""]);
                  n.objectStore("local-forage-detect-blob-support").put(r, "key"), n.onabort = function (e) {
                    e.preventDefault(), e.stopPropagation(), t(!1);
                  }, n.oncomplete = function () {
                    var e = navigator.userAgent.match(/Chrome\/(\d+)/),
                        n = navigator.userAgent.match(/Edge\//);
                    t(n || !e || parseInt(e[1], 10) >= 43);
                  };
                })["catch"](function () {
                  return !1;
                });
              }(e).then(function (e) {
                return l = e;
              });
            }

            function v(e) {
              var t = d[e.name],
                  n = {};
              n.promise = new a(function (e, t) {
                n.resolve = e, n.reject = t;
              }), t.deferredOperations.push(n), t.dbReady ? t.dbReady = t.dbReady.then(function () {
                return n.promise;
              }) : t.dbReady = n.promise;
            }

            function m(e) {
              var t = d[e.name].deferredOperations.pop();
              if (t) return t.resolve(), t.promise;
            }

            function y(e, t) {
              var n = d[e.name].deferredOperations.pop();
              if (n) return n.reject(t), n.promise;
            }

            function g(e, t) {
              return new a(function (n, r) {
                if (d[e.name] = d[e.name] || {
                  forages: [],
                  db: null,
                  dbReady: null,
                  deferredOperations: []
                }, e.db) {
                  if (!t) return n(e.db);
                  v(e), e.db.close();
                }

                var i = [e.name];
                t && i.push(e.version);
                var a = o.open.apply(o, i);
                t && (a.onupgradeneeded = function (t) {
                  var n = a.result;

                  try {
                    n.createObjectStore(e.storeName), t.oldVersion <= 1 && n.createObjectStore("local-forage-detect-blob-support");
                  } catch (e) {
                    if ("ConstraintError" !== e.name) throw e;
                  }
                }), a.onerror = function (e) {
                  e.preventDefault(), r(a.error);
                }, a.onsuccess = function () {
                  n(a.result), m(e);
                };
              });
            }

            function b(e) {
              return g(e, !1);
            }

            function w(e) {
              return g(e, !0);
            }

            function _(e, t) {
              if (!e.db) return !0;
              var n = !e.db.objectStoreNames.contains(e.storeName),
                  r = e.version < e.db.version,
                  o = e.version > e.db.version;

              if (r && (e.version, e.version = e.db.version), o || n) {
                if (n) {
                  var i = e.db.version + 1;
                  i > e.version && (e.version = i);
                }

                return !0;
              }

              return !1;
            }

            function S(e) {
              return i([function (e) {
                for (var t = e.length, n = new ArrayBuffer(t), r = new Uint8Array(n), o = 0; o < t; o++) {
                  r[o] = e.charCodeAt(o);
                }

                return n;
              }(atob(e.data))], {
                type: e.type
              });
            }

            function I(e) {
              return e && e.__local_forage_encoded_blob;
            }

            function E(e) {
              var t = this,
                  n = t._initReady().then(function () {
                var e = d[t._dbInfo.name];
                if (e && e.dbReady) return e.dbReady;
              });

              return u(n, e, e), n;
            }

            function O(e, t, n, r) {
              void 0 === r && (r = 1);

              try {
                var o = e.db.transaction(e.storeName, t);
                n(null, o);
              } catch (o) {
                if (r > 0 && (!e.db || "InvalidStateError" === o.name || "NotFoundError" === o.name)) return a.resolve().then(function () {
                  if (!e.db || "NotFoundError" === o.name && !e.db.objectStoreNames.contains(e.storeName) && e.version <= e.db.version) return e.db && (e.version = e.db.version + 1), w(e);
                }).then(function () {
                  return function (e) {
                    v(e);

                    for (var t = d[e.name], n = t.forages, r = 0; r < n.length; r++) {
                      var o = n[r];
                      o._dbInfo.db && (o._dbInfo.db.close(), o._dbInfo.db = null);
                    }

                    return e.db = null, b(e).then(function (t) {
                      return e.db = t, _(e) ? w(e) : t;
                    }).then(function (r) {
                      e.db = t.db = r;

                      for (var o = 0; o < n.length; o++) {
                        n[o]._dbInfo.db = r;
                      }
                    })["catch"](function (t) {
                      throw y(e, t), t;
                    });
                  }(e).then(function () {
                    O(e, t, n, r - 1);
                  });
                })["catch"](n);
                n(o);
              }
            }

            var x = {
              _driver: "asyncStorage",
              _initStorage: function _initStorage(e) {
                var t = this,
                    n = {
                  db: null
                };
                if (e) for (var r in e) {
                  n[r] = e[r];
                }
                var o = d[n.name];
                o || (o = {
                  forages: [],
                  db: null,
                  dbReady: null,
                  deferredOperations: []
                }, d[n.name] = o), o.forages.push(t), t._initReady || (t._initReady = t.ready, t.ready = E);
                var i = [];

                function s() {
                  return a.resolve();
                }

                for (var u = 0; u < o.forages.length; u++) {
                  var c = o.forages[u];
                  c !== t && i.push(c._initReady()["catch"](s));
                }

                var f = o.forages.slice(0);
                return a.all(i).then(function () {
                  return n.db = o.db, b(n);
                }).then(function (e) {
                  return n.db = e, _(n, t._defaultConfig.version) ? w(n) : e;
                }).then(function (e) {
                  n.db = o.db = e, t._dbInfo = n;

                  for (var r = 0; r < f.length; r++) {
                    var i = f[r];
                    i !== t && (i._dbInfo.db = n.db, i._dbInfo.version = n.version);
                  }
                });
              },
              _support: function () {
                try {
                  if (!o || !o.open) return !1;
                  var e = "undefined" != typeof openDatabase && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform),
                      t = "function" == typeof fetch && -1 !== fetch.toString().indexOf("[native code");
                  return (!e || t) && "undefined" != typeof indexedDB && "undefined" != typeof IDBKeyRange;
                } catch (e) {
                  return !1;
                }
              }(),
              iterate: function iterate(e, t) {
                var n = this,
                    r = new a(function (t, r) {
                  n.ready().then(function () {
                    O(n._dbInfo, "readonly", function (o, i) {
                      if (o) return r(o);

                      try {
                        var a = i.objectStore(n._dbInfo.storeName).openCursor(),
                            s = 1;
                        a.onsuccess = function () {
                          var n = a.result;

                          if (n) {
                            var r = n.value;
                            I(r) && (r = S(r));
                            var o = e(r, n.key, s++);
                            void 0 !== o ? t(o) : n["continue"]();
                          } else t();
                        }, a.onerror = function () {
                          r(a.error);
                        };
                      } catch (e) {
                        r(e);
                      }
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              getItem: function getItem(e, t) {
                var n = this;
                e = c(e);
                var r = new a(function (t, r) {
                  n.ready().then(function () {
                    O(n._dbInfo, "readonly", function (o, i) {
                      if (o) return r(o);

                      try {
                        var a = i.objectStore(n._dbInfo.storeName).get(e);
                        a.onsuccess = function () {
                          var e = a.result;
                          void 0 === e && (e = null), I(e) && (e = S(e)), t(e);
                        }, a.onerror = function () {
                          r(a.error);
                        };
                      } catch (e) {
                        r(e);
                      }
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              setItem: function setItem(e, t, n) {
                var r = this;
                e = c(e);
                var o = new a(function (n, o) {
                  var i;
                  r.ready().then(function () {
                    return i = r._dbInfo, "[object Blob]" === p.call(t) ? h(i.db).then(function (e) {
                      return e ? t : (n = t, new a(function (e, t) {
                        var r = new FileReader();
                        r.onerror = t, r.onloadend = function (t) {
                          var r = btoa(t.target.result || "");
                          e({
                            __local_forage_encoded_blob: !0,
                            data: r,
                            type: n.type
                          });
                        }, r.readAsBinaryString(n);
                      }));
                      var n;
                    }) : t;
                  }).then(function (t) {
                    O(r._dbInfo, "readwrite", function (i, a) {
                      if (i) return o(i);

                      try {
                        var s = a.objectStore(r._dbInfo.storeName);
                        null === t && (t = void 0);
                        var u = s.put(t, e);
                        a.oncomplete = function () {
                          void 0 === t && (t = null), n(t);
                        }, a.onabort = a.onerror = function () {
                          var e = u.error ? u.error : u.transaction.error;
                          o(e);
                        };
                      } catch (e) {
                        o(e);
                      }
                    });
                  })["catch"](o);
                });
                return s(o, n), o;
              },
              removeItem: function removeItem(e, t) {
                var n = this;
                e = c(e);
                var r = new a(function (t, r) {
                  n.ready().then(function () {
                    O(n._dbInfo, "readwrite", function (o, i) {
                      if (o) return r(o);

                      try {
                        var a = i.objectStore(n._dbInfo.storeName)["delete"](e);
                        i.oncomplete = function () {
                          t();
                        }, i.onerror = function () {
                          r(a.error);
                        }, i.onabort = function () {
                          var e = a.error ? a.error : a.transaction.error;
                          r(e);
                        };
                      } catch (e) {
                        r(e);
                      }
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              clear: function clear(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    O(t._dbInfo, "readwrite", function (r, o) {
                      if (r) return n(r);

                      try {
                        var i = o.objectStore(t._dbInfo.storeName).clear();
                        o.oncomplete = function () {
                          e();
                        }, o.onabort = o.onerror = function () {
                          var e = i.error ? i.error : i.transaction.error;
                          n(e);
                        };
                      } catch (e) {
                        n(e);
                      }
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              length: function length(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    O(t._dbInfo, "readonly", function (r, o) {
                      if (r) return n(r);

                      try {
                        var i = o.objectStore(t._dbInfo.storeName).count();
                        i.onsuccess = function () {
                          e(i.result);
                        }, i.onerror = function () {
                          n(i.error);
                        };
                      } catch (e) {
                        n(e);
                      }
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              key: function key(e, t) {
                var n = this,
                    r = new a(function (t, r) {
                  e < 0 ? t(null) : n.ready().then(function () {
                    O(n._dbInfo, "readonly", function (o, i) {
                      if (o) return r(o);

                      try {
                        var a = i.objectStore(n._dbInfo.storeName),
                            s = !1,
                            u = a.openKeyCursor();
                        u.onsuccess = function () {
                          var n = u.result;
                          n ? 0 === e || s ? t(n.key) : (s = !0, n.advance(e)) : t(null);
                        }, u.onerror = function () {
                          r(u.error);
                        };
                      } catch (e) {
                        r(e);
                      }
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              keys: function keys(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    O(t._dbInfo, "readonly", function (r, o) {
                      if (r) return n(r);

                      try {
                        var i = o.objectStore(t._dbInfo.storeName).openKeyCursor(),
                            a = [];
                        i.onsuccess = function () {
                          var t = i.result;
                          t ? (a.push(t.key), t["continue"]()) : e(a);
                        }, i.onerror = function () {
                          n(i.error);
                        };
                      } catch (e) {
                        n(e);
                      }
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              dropInstance: function dropInstance(e, t) {
                t = f.apply(this, arguments);
                var n = this.config();
                (e = "function" != typeof e && e || {}).name || (e.name = e.name || n.name, e.storeName = e.storeName || n.storeName);
                var r,
                    i = this;

                if (e.name) {
                  var u = e.name === n.name && i._dbInfo.db,
                      c = u ? a.resolve(i._dbInfo.db) : b(e).then(function (t) {
                    var n = d[e.name],
                        r = n.forages;
                    n.db = t;

                    for (var o = 0; o < r.length; o++) {
                      r[o]._dbInfo.db = t;
                    }

                    return t;
                  });
                  r = e.storeName ? c.then(function (t) {
                    if (t.objectStoreNames.contains(e.storeName)) {
                      var n = t.version + 1;
                      v(e);
                      var r = d[e.name],
                          i = r.forages;
                      t.close();

                      for (var s = 0; s < i.length; s++) {
                        var u = i[s];
                        u._dbInfo.db = null, u._dbInfo.version = n;
                      }

                      return new a(function (t, r) {
                        var i = o.open(e.name, n);
                        i.onerror = function (e) {
                          i.result.close(), r(e);
                        }, i.onupgradeneeded = function () {
                          i.result.deleteObjectStore(e.storeName);
                        }, i.onsuccess = function () {
                          var e = i.result;
                          e.close(), t(e);
                        };
                      }).then(function (e) {
                        r.db = e;

                        for (var t = 0; t < i.length; t++) {
                          var n = i[t];
                          n._dbInfo.db = e, m(n._dbInfo);
                        }
                      })["catch"](function (t) {
                        throw (y(e, t) || a.resolve())["catch"](function () {}), t;
                      });
                    }
                  }) : c.then(function (t) {
                    v(e);
                    var n = d[e.name],
                        r = n.forages;
                    t.close();

                    for (var i = 0; i < r.length; i++) {
                      r[i]._dbInfo.db = null;
                    }

                    return new a(function (t, n) {
                      var r = o.deleteDatabase(e.name);
                      r.onerror = r.onblocked = function (e) {
                        var t = r.result;
                        t && t.close(), n(e);
                      }, r.onsuccess = function () {
                        var e = r.result;
                        e && e.close(), t(e);
                      };
                    }).then(function (e) {
                      n.db = e;

                      for (var t = 0; t < r.length; t++) {
                        m(r[t]._dbInfo);
                      }
                    })["catch"](function (t) {
                      throw (y(e, t) || a.resolve())["catch"](function () {}), t;
                    });
                  });
                } else r = a.reject("Invalid arguments");

                return s(r, t), r;
              }
            },
                j = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
                A = /^~~local_forage_type~([^~]+)~/,
                N = "__lfsc__:".length,
                k = N + "arbf".length,
                R = Object.prototype.toString;

            function T(e) {
              var t,
                  n,
                  r,
                  o,
                  i,
                  a = .75 * e.length,
                  s = e.length,
                  u = 0;
              "=" === e[e.length - 1] && (a--, "=" === e[e.length - 2] && a--);
              var c = new ArrayBuffer(a),
                  f = new Uint8Array(c);

              for (t = 0; t < s; t += 4) {
                n = j.indexOf(e[t]), r = j.indexOf(e[t + 1]), o = j.indexOf(e[t + 2]), i = j.indexOf(e[t + 3]), f[u++] = n << 2 | r >> 4, f[u++] = (15 & r) << 4 | o >> 2, f[u++] = (3 & o) << 6 | 63 & i;
              }

              return c;
            }

            function C(e) {
              var t,
                  n = new Uint8Array(e),
                  r = "";

              for (t = 0; t < n.length; t += 3) {
                r += j[n[t] >> 2], r += j[(3 & n[t]) << 4 | n[t + 1] >> 4], r += j[(15 & n[t + 1]) << 2 | n[t + 2] >> 6], r += j[63 & n[t + 2]];
              }

              return n.length % 3 == 2 ? r = r.substring(0, r.length - 1) + "=" : n.length % 3 == 1 && (r = r.substring(0, r.length - 2) + "=="), r;
            }

            var D = {
              serialize: function serialize(e, t) {
                var n = "";

                if (e && (n = R.call(e)), e && ("[object ArrayBuffer]" === n || e.buffer && "[object ArrayBuffer]" === R.call(e.buffer))) {
                  var r,
                      o = "__lfsc__:";
                  e instanceof ArrayBuffer ? (r = e, o += "arbf") : (r = e.buffer, "[object Int8Array]" === n ? o += "si08" : "[object Uint8Array]" === n ? o += "ui08" : "[object Uint8ClampedArray]" === n ? o += "uic8" : "[object Int16Array]" === n ? o += "si16" : "[object Uint16Array]" === n ? o += "ur16" : "[object Int32Array]" === n ? o += "si32" : "[object Uint32Array]" === n ? o += "ui32" : "[object Float32Array]" === n ? o += "fl32" : "[object Float64Array]" === n ? o += "fl64" : t(new Error("Failed to get type for BinaryArray"))), t(o + C(r));
                } else if ("[object Blob]" === n) {
                  var i = new FileReader();
                  i.onload = function () {
                    var n = "~~local_forage_type~" + e.type + "~" + C(this.result);
                    t("__lfsc__:blob" + n);
                  }, i.readAsArrayBuffer(e);
                } else try {
                  t(JSON.stringify(e));
                } catch (e) {
                  t(null, e);
                }
              },
              deserialize: function deserialize(e) {
                if ("__lfsc__:" !== e.substring(0, N)) return JSON.parse(e);
                var t,
                    n = e.substring(k),
                    r = e.substring(N, k);

                if ("blob" === r && A.test(n)) {
                  var o = n.match(A);
                  t = o[1], n = n.substring(o[0].length);
                }

                var a = T(n);

                switch (r) {
                  case "arbf":
                    return a;

                  case "blob":
                    return i([a], {
                      type: t
                    });

                  case "si08":
                    return new Int8Array(a);

                  case "ui08":
                    return new Uint8Array(a);

                  case "uic8":
                    return new Uint8ClampedArray(a);

                  case "si16":
                    return new Int16Array(a);

                  case "ur16":
                    return new Uint16Array(a);

                  case "si32":
                    return new Int32Array(a);

                  case "ui32":
                    return new Uint32Array(a);

                  case "fl32":
                    return new Float32Array(a);

                  case "fl64":
                    return new Float64Array(a);

                  default:
                    throw new Error("Unkown type: " + r);
                }
              },
              stringToBuffer: T,
              bufferToString: C
            };

            function P(e, t, n, r) {
              e.executeSql("CREATE TABLE IF NOT EXISTS " + t.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], n, r);
            }

            function B(e, t, n, r, o, i) {
              e.executeSql(n, r, o, function (e, a) {
                a.code === a.SYNTAX_ERR ? e.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [t.storeName], function (e, s) {
                  s.rows.length ? i(e, a) : P(e, t, function () {
                    e.executeSql(n, r, o, i);
                  }, i);
                }, i) : i(e, a);
              }, i);
            }

            function U(e, t, n, r) {
              var o = this;
              e = c(e);
              var i = new a(function (i, a) {
                o.ready().then(function () {
                  void 0 === t && (t = null);
                  var s = t,
                      u = o._dbInfo;
                  u.serializer.serialize(t, function (t, c) {
                    c ? a(c) : u.db.transaction(function (n) {
                      B(n, u, "INSERT OR REPLACE INTO " + u.storeName + " (key, value) VALUES (?, ?)", [e, t], function () {
                        i(s);
                      }, function (e, t) {
                        a(t);
                      });
                    }, function (t) {
                      if (t.code === t.QUOTA_ERR) {
                        if (r > 0) return void i(U.apply(o, [e, s, n, r - 1]));
                        a(t);
                      }
                    });
                  });
                })["catch"](a);
              });
              return s(i, n), i;
            }

            function q(e) {
              return new a(function (t, n) {
                e.transaction(function (r) {
                  r.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (n, r) {
                    for (var o = [], i = 0; i < r.rows.length; i++) {
                      o.push(r.rows.item(i).name);
                    }

                    t({
                      db: e,
                      storeNames: o
                    });
                  }, function (e, t) {
                    n(t);
                  });
                }, function (e) {
                  n(e);
                });
              });
            }

            var L = {
              _driver: "webSQLStorage",
              _initStorage: function _initStorage(e) {
                var t = this,
                    n = {
                  db: null
                };
                if (e) for (var r in e) {
                  n[r] = "string" != typeof e[r] ? e[r].toString() : e[r];
                }
                var o = new a(function (e, r) {
                  try {
                    n.db = openDatabase(n.name, String(n.version), n.description, n.size);
                  } catch (e) {
                    return r(e);
                  }

                  n.db.transaction(function (o) {
                    P(o, n, function () {
                      t._dbInfo = n, e();
                    }, function (e, t) {
                      r(t);
                    });
                  }, r);
                });
                return n.serializer = D, o;
              },
              _support: "function" == typeof openDatabase,
              iterate: function iterate(e, t) {
                var n = this,
                    r = new a(function (t, r) {
                  n.ready().then(function () {
                    var o = n._dbInfo;
                    o.db.transaction(function (n) {
                      B(n, o, "SELECT * FROM " + o.storeName, [], function (n, r) {
                        for (var i = r.rows, a = i.length, s = 0; s < a; s++) {
                          var u = i.item(s),
                              c = u.value;
                          if (c && (c = o.serializer.deserialize(c)), void 0 !== (c = e(c, u.key, s + 1))) return void t(c);
                        }

                        t();
                      }, function (e, t) {
                        r(t);
                      });
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              getItem: function getItem(e, t) {
                var n = this;
                e = c(e);
                var r = new a(function (t, r) {
                  n.ready().then(function () {
                    var o = n._dbInfo;
                    o.db.transaction(function (n) {
                      B(n, o, "SELECT * FROM " + o.storeName + " WHERE key = ? LIMIT 1", [e], function (e, n) {
                        var r = n.rows.length ? n.rows.item(0).value : null;
                        r && (r = o.serializer.deserialize(r)), t(r);
                      }, function (e, t) {
                        r(t);
                      });
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              setItem: function setItem(e, t, n) {
                return U.apply(this, [e, t, n, 1]);
              },
              removeItem: function removeItem(e, t) {
                var n = this;
                e = c(e);
                var r = new a(function (t, r) {
                  n.ready().then(function () {
                    var o = n._dbInfo;
                    o.db.transaction(function (n) {
                      B(n, o, "DELETE FROM " + o.storeName + " WHERE key = ?", [e], function () {
                        t();
                      }, function (e, t) {
                        r(t);
                      });
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              clear: function clear(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    var r = t._dbInfo;
                    r.db.transaction(function (t) {
                      B(t, r, "DELETE FROM " + r.storeName, [], function () {
                        e();
                      }, function (e, t) {
                        n(t);
                      });
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              length: function length(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    var r = t._dbInfo;
                    r.db.transaction(function (t) {
                      B(t, r, "SELECT COUNT(key) as c FROM " + r.storeName, [], function (t, n) {
                        var r = n.rows.item(0).c;
                        e(r);
                      }, function (e, t) {
                        n(t);
                      });
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              key: function key(e, t) {
                var n = this,
                    r = new a(function (t, r) {
                  n.ready().then(function () {
                    var o = n._dbInfo;
                    o.db.transaction(function (n) {
                      B(n, o, "SELECT key FROM " + o.storeName + " WHERE id = ? LIMIT 1", [e + 1], function (e, n) {
                        var r = n.rows.length ? n.rows.item(0).key : null;
                        t(r);
                      }, function (e, t) {
                        r(t);
                      });
                    });
                  })["catch"](r);
                });
                return s(r, t), r;
              },
              keys: function keys(e) {
                var t = this,
                    n = new a(function (e, n) {
                  t.ready().then(function () {
                    var r = t._dbInfo;
                    r.db.transaction(function (t) {
                      B(t, r, "SELECT key FROM " + r.storeName, [], function (t, n) {
                        for (var r = [], o = 0; o < n.rows.length; o++) {
                          r.push(n.rows.item(o).key);
                        }

                        e(r);
                      }, function (e, t) {
                        n(t);
                      });
                    });
                  })["catch"](n);
                });
                return s(n, e), n;
              },
              dropInstance: function dropInstance(e, t) {
                t = f.apply(this, arguments);
                var n = this.config();
                (e = "function" != typeof e && e || {}).name || (e.name = e.name || n.name, e.storeName = e.storeName || n.storeName);
                var r,
                    o = this;
                return s(r = e.name ? new a(function (t) {
                  var r;
                  r = e.name === n.name ? o._dbInfo.db : openDatabase(e.name, "", "", 0), e.storeName ? t({
                    db: r,
                    storeNames: [e.storeName]
                  }) : t(q(r));
                }).then(function (e) {
                  return new a(function (t, n) {
                    e.db.transaction(function (r) {
                      function o(e) {
                        return new a(function (t, n) {
                          r.executeSql("DROP TABLE IF EXISTS " + e, [], function () {
                            t();
                          }, function (e, t) {
                            n(t);
                          });
                        });
                      }

                      for (var i = [], s = 0, u = e.storeNames.length; s < u; s++) {
                        i.push(o(e.storeNames[s]));
                      }

                      a.all(i).then(function () {
                        t();
                      })["catch"](function (e) {
                        n(e);
                      });
                    }, function (e) {
                      n(e);
                    });
                  });
                }) : a.reject("Invalid arguments"), t), r;
              }
            };

            function M(e, t) {
              var n = e.name + "/";
              return e.storeName !== t.storeName && (n += e.storeName + "/"), n;
            }

            function F() {
              return !function () {
                try {
                  return localStorage.setItem("_localforage_support_test", !0), localStorage.removeItem("_localforage_support_test"), !1;
                } catch (e) {
                  return !0;
                }
              }() || localStorage.length > 0;
            }

            var z = {
              _driver: "localStorageWrapper",
              _initStorage: function _initStorage(e) {
                var t = {};
                if (e) for (var n in e) {
                  t[n] = e[n];
                }
                return t.keyPrefix = M(e, this._defaultConfig), F() ? (this._dbInfo = t, t.serializer = D, a.resolve()) : a.reject();
              },
              _support: function () {
                try {
                  return "undefined" != typeof localStorage && "setItem" in localStorage && !!localStorage.setItem;
                } catch (e) {
                  return !1;
                }
              }(),
              iterate: function iterate(e, t) {
                var n = this,
                    r = n.ready().then(function () {
                  for (var t = n._dbInfo, r = t.keyPrefix, o = r.length, i = localStorage.length, a = 1, s = 0; s < i; s++) {
                    var u = localStorage.key(s);

                    if (0 === u.indexOf(r)) {
                      var c = localStorage.getItem(u);
                      if (c && (c = t.serializer.deserialize(c)), void 0 !== (c = e(c, u.substring(o), a++))) return c;
                    }
                  }
                });
                return s(r, t), r;
              },
              getItem: function getItem(e, t) {
                var n = this;
                e = c(e);
                var r = n.ready().then(function () {
                  var t = n._dbInfo,
                      r = localStorage.getItem(t.keyPrefix + e);
                  return r && (r = t.serializer.deserialize(r)), r;
                });
                return s(r, t), r;
              },
              setItem: function setItem(e, t, n) {
                var r = this;
                e = c(e);
                var o = r.ready().then(function () {
                  void 0 === t && (t = null);
                  var n = t;
                  return new a(function (o, i) {
                    var a = r._dbInfo;
                    a.serializer.serialize(t, function (t, r) {
                      if (r) i(r);else try {
                        localStorage.setItem(a.keyPrefix + e, t), o(n);
                      } catch (e) {
                        "QuotaExceededError" !== e.name && "NS_ERROR_DOM_QUOTA_REACHED" !== e.name || i(e), i(e);
                      }
                    });
                  });
                });
                return s(o, n), o;
              },
              removeItem: function removeItem(e, t) {
                var n = this;
                e = c(e);
                var r = n.ready().then(function () {
                  var t = n._dbInfo;
                  localStorage.removeItem(t.keyPrefix + e);
                });
                return s(r, t), r;
              },
              clear: function clear(e) {
                var t = this,
                    n = t.ready().then(function () {
                  for (var e = t._dbInfo.keyPrefix, n = localStorage.length - 1; n >= 0; n--) {
                    var r = localStorage.key(n);
                    0 === r.indexOf(e) && localStorage.removeItem(r);
                  }
                });
                return s(n, e), n;
              },
              length: function length(e) {
                var t = this.keys().then(function (e) {
                  return e.length;
                });
                return s(t, e), t;
              },
              key: function key(e, t) {
                var n = this,
                    r = n.ready().then(function () {
                  var t,
                      r = n._dbInfo;

                  try {
                    t = localStorage.key(e);
                  } catch (e) {
                    t = null;
                  }

                  return t && (t = t.substring(r.keyPrefix.length)), t;
                });
                return s(r, t), r;
              },
              keys: function keys(e) {
                var t = this,
                    n = t.ready().then(function () {
                  for (var e = t._dbInfo, n = localStorage.length, r = [], o = 0; o < n; o++) {
                    var i = localStorage.key(o);
                    0 === i.indexOf(e.keyPrefix) && r.push(i.substring(e.keyPrefix.length));
                  }

                  return r;
                });
                return s(n, e), n;
              },
              dropInstance: function dropInstance(e, t) {
                if (t = f.apply(this, arguments), !(e = "function" != typeof e && e || {}).name) {
                  var n = this.config();
                  e.name = e.name || n.name, e.storeName = e.storeName || n.storeName;
                }

                var r,
                    o = this;
                return s(r = e.name ? new a(function (t) {
                  e.storeName ? t(M(e, o._defaultConfig)) : t(e.name + "/");
                }).then(function (e) {
                  for (var t = localStorage.length - 1; t >= 0; t--) {
                    var n = localStorage.key(t);
                    0 === n.indexOf(e) && localStorage.removeItem(n);
                  }
                }) : a.reject("Invalid arguments"), t), r;
              }
            },
                V = function V(e, t) {
              for (var n, r, o = e.length, i = 0; i < o;) {
                if ((n = e[i]) === (r = t) || "number" == typeof n && "number" == typeof r && isNaN(n) && isNaN(r)) return !0;
                i++;
              }

              return !1;
            },
                J = Array.isArray || function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            },
                K = {},
                W = {},
                H = {
              INDEXEDDB: x,
              WEBSQL: L,
              LOCALSTORAGE: z
            },
                X = [H.INDEXEDDB._driver, H.WEBSQL._driver, H.LOCALSTORAGE._driver],
                Q = ["dropInstance"],
                G = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(Q),
                $ = {
              description: "",
              driver: X.slice(),
              name: "localforage",
              size: 4980736,
              storeName: "keyvaluepairs",
              version: 1
            };

            function Y(e, t) {
              e[t] = function () {
                var n = arguments;
                return e.ready().then(function () {
                  return e[t].apply(e, n);
                });
              };
            }

            function Z() {
              for (var e = 1; e < arguments.length; e++) {
                var t = arguments[e];
                if (t) for (var n in t) {
                  t.hasOwnProperty(n) && (J(t[n]) ? arguments[0][n] = t[n].slice() : arguments[0][n] = t[n]);
                }
              }

              return arguments[0];
            }

            var ee = new (function () {
              function e(t) {
                for (var n in function (e, t) {
                  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), H) {
                  if (H.hasOwnProperty(n)) {
                    var r = H[n],
                        o = r._driver;
                    this[n] = o, K[o] || this.defineDriver(r);
                  }
                }

                this._defaultConfig = Z({}, $), this._config = Z({}, this._defaultConfig, t), this._driverSet = null, this._initDriver = null, this._ready = !1, this._dbInfo = null, this._wrapLibraryMethodsWithReady(), this.setDriver(this._config.driver)["catch"](function () {});
              }

              return e.prototype.config = function (e) {
                if ("object" === (void 0 === e ? "undefined" : r(e))) {
                  if (this._ready) return new Error("Can't call config() after localforage has been used.");

                  for (var t in e) {
                    if ("storeName" === t && (e[t] = e[t].replace(/\W/g, "_")), "version" === t && "number" != typeof e[t]) return new Error("Database version must be a number.");
                    this._config[t] = e[t];
                  }

                  return !("driver" in e) || !e.driver || this.setDriver(this._config.driver);
                }

                return "string" == typeof e ? this._config[e] : this._config;
              }, e.prototype.defineDriver = function (e, t, n) {
                var r = new a(function (t, n) {
                  try {
                    var r = e._driver,
                        o = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                    if (!e._driver) return void n(o);

                    for (var i = G.concat("_initStorage"), u = 0, c = i.length; u < c; u++) {
                      var f = i[u];
                      if ((!V(Q, f) || e[f]) && "function" != typeof e[f]) return void n(o);
                    }

                    !function () {
                      for (var t = function t(e) {
                        return function () {
                          var t = new Error("Method " + e + " is not implemented by the current driver"),
                              n = a.reject(t);
                          return s(n, arguments[arguments.length - 1]), n;
                        };
                      }, n = 0, r = Q.length; n < r; n++) {
                        var o = Q[n];
                        e[o] || (e[o] = t(o));
                      }
                    }();

                    var l = function l(n) {
                      K[r], K[r] = e, W[r] = n, t();
                    };

                    "_support" in e ? e._support && "function" == typeof e._support ? e._support().then(l, n) : l(!!e._support) : l(!0);
                  } catch (e) {
                    n(e);
                  }
                });
                return u(r, t, n), r;
              }, e.prototype.driver = function () {
                return this._driver || null;
              }, e.prototype.getDriver = function (e, t, n) {
                var r = K[e] ? a.resolve(K[e]) : a.reject(new Error("Driver not found."));
                return u(r, t, n), r;
              }, e.prototype.getSerializer = function (e) {
                var t = a.resolve(D);
                return u(t, e), t;
              }, e.prototype.ready = function (e) {
                var t = this,
                    n = t._driverSet.then(function () {
                  return null === t._ready && (t._ready = t._initDriver()), t._ready;
                });

                return u(n, e, e), n;
              }, e.prototype.setDriver = function (e, t, n) {
                var r = this;
                J(e) || (e = [e]);

                var o = this._getSupportedDrivers(e);

                function i() {
                  r._config.driver = r.driver();
                }

                function s(e) {
                  return r._extend(e), i(), r._ready = r._initStorage(r._config), r._ready;
                }

                var c = null !== this._driverSet ? this._driverSet["catch"](function () {
                  return a.resolve();
                }) : a.resolve();
                return this._driverSet = c.then(function () {
                  var e = o[0];
                  return r._dbInfo = null, r._ready = null, r.getDriver(e).then(function (e) {
                    r._driver = e._driver, i(), r._wrapLibraryMethodsWithReady(), r._initDriver = function (e) {
                      return function () {
                        var t = 0;
                        return function n() {
                          for (; t < e.length;) {
                            var o = e[t];
                            return t++, r._dbInfo = null, r._ready = null, r.getDriver(o).then(s)["catch"](n);
                          }

                          i();
                          var u = new Error("No available storage method found.");
                          return r._driverSet = a.reject(u), r._driverSet;
                        }();
                      };
                    }(o);
                  });
                })["catch"](function () {
                  i();
                  var e = new Error("No available storage method found.");
                  return r._driverSet = a.reject(e), r._driverSet;
                }), u(this._driverSet, t, n), this._driverSet;
              }, e.prototype.supports = function (e) {
                return !!W[e];
              }, e.prototype._extend = function (e) {
                Z(this, e);
              }, e.prototype._getSupportedDrivers = function (e) {
                for (var t = [], n = 0, r = e.length; n < r; n++) {
                  var o = e[n];
                  this.supports(o) && t.push(o);
                }

                return t;
              }, e.prototype._wrapLibraryMethodsWithReady = function () {
                for (var e = 0, t = G.length; e < t; e++) {
                  Y(this, G[e]);
                }
              }, e.prototype.createInstance = function (t) {
                return new e(t);
              }, e;
            }())();
            t.exports = ee;
          }, {
            3: 3
          }]
        }, {}, [4])(4);
      }).call(this, n(21));
    }, function (e, t, n) {
      e.exports = n(22);
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return o;
      });

      var r = function r() {};

      function o(e) {
        if (!e || !e.reduce || !e.length) throw new TypeError("createPipeline 方法需要传入至少有一个 pipe 的数组");
        return 1 === e.length ? function (t, n) {
          e[0](t, n || r);
        } : e.reduce(function (e, t) {
          return function (n, o) {
            return void 0 === o && (o = r), e(n, function (e) {
              return null == t ? void 0 : t(e, o);
            });
          };
        });
      }
    }, function (e, t, n) {
      var r = n(0),
          o = function () {
        function e(e, t, n, o) {
          this.requestParams = {}, this.network = o, this.requestParams.attaid = r.a, this.requestParams.token = r.c, this.requestParams.product_id = e.appkey, this.requestParams.platform = n, this.requestParams.uin = t.deviceId, this.requestParams.model = "", this.requestParams.os = n, this.requestParams.app_version = e.appVersion, this.requestParams.sdk_version = t.sdkVersion, this.requestParams.error_stack = "";
        }

        return e.prototype.reportError = function (e, t) {
          this.requestParams._dc = Math.random(), this.requestParams.error_msg = t, this.requestParams.error_code = e, this.network.get(r.b, {
            params: this.requestParams
          });
        }, e;
      }();

      t.a = o;
    }, function (e, t, n) {
      n.d(t, "a", function () {
        return r;
      });

      var r = function r() {};
    }, function (e, t, n) {
      var r = n(0),
          o = function () {
        function e(e, t, n, o) {
          this.strategy = {
            isEventUpOnOff: !0,
            httpsUploadUrl: r.i,
            requestInterval: 30,
            blacklist: [],
            samplelist: []
          }, this.realSample = {}, this.appkey = "", this.appkey = e.appkey, this.storage = n;

          try {
            var i = JSON.parse(this.storage.getItem(r.d));
            i && this.processData(i);
          } catch (e) {}

          this.needRequestConfig() && this.requestConfig(e.appVersion, t, o);
        }

        return e.prototype.requestConfig = function (e, t, n) {
          var o = this;
          this.storage.setItem(r.f, Date.now().toString()), n.post(r.e, {
            platformId: "undefined" == typeof wx ? "3" : "4",
            mainAppKey: this.appkey,
            appVersion: e,
            sdkVersion: t.sdkVersion,
            osVersion: t.userAgent,
            model: "",
            packageName: "",
            params: {
              A3: t.deviceId
            }
          }).then(function (e) {
            if (0 == e.data.ret) try {
              var t = JSON.parse(e.data.beaconConfig);
              t && (o.processData(t), o.storage.setItem(r.d, e.data.beaconConfig));
            } catch (e) {} else o.processData(null), o.storage.setItem(r.d, "");
          })["catch"](function (e) {});
        }, e.prototype.processData = function (e) {
          var t, n, r, o, i;
          this.strategy.isEventUpOnOff = null !== (t = null == e ? void 0 : e.isEventUpOnOff) && void 0 !== t ? t : this.strategy.isEventUpOnOff, this.strategy.httpsUploadUrl = null !== (n = null == e ? void 0 : e.httpsUploadUrl) && void 0 !== n ? n : this.strategy.httpsUploadUrl, this.strategy.requestInterval = null !== (r = null == e ? void 0 : e.requestInterval) && void 0 !== r ? r : this.strategy.requestInterval, this.strategy.blacklist = null !== (o = null == e ? void 0 : e.blacklist) && void 0 !== o ? o : this.strategy.blacklist, this.strategy.samplelist = null !== (i = null == e ? void 0 : e.samplelist) && void 0 !== i ? i : this.strategy.samplelist;

          for (var a = 0, s = this.strategy.samplelist; a < s.length; a++) {
            var u = s[a].split(",");
            2 == u.length && (this.realSample[u[0]] = u[1]);
          }
        }, e.prototype.needRequestConfig = function () {
          var e = Number(this.storage.getItem(r.f));
          return Date.now() - e > 60 * this.strategy.requestInterval * 1e3;
        }, e.prototype.getUploadUrl = function () {
          return this.strategy.httpsUploadUrl + "?appkey=" + this.appkey;
        }, e.prototype.isBlackEvent = function (e) {
          return -1 != this.strategy.blacklist.indexOf(e);
        }, e.prototype.isEventUpOnOff = function () {
          return this.strategy.isEventUpOnOff;
        }, e.prototype.isSampleEvent = function (e) {
          return !!Object.prototype.hasOwnProperty.call(this.realSample, e) && this.realSample[e] < Math.floor(Math.random() * Math.floor(1e4));
        }, e;
      }();

      t.a = o;
    }, function (e, t) {}, function (e, t, n) {
      n(6), n(7), n(8);
    }, function (e, t, n) {
      e.exports = function (e, t) {
        return function () {
          for (var n = new Array(arguments.length), r = 0; r < n.length; r++) {
            n[r] = arguments[r];
          }

          return e.apply(t, n);
        };
      };
    }, function (e, t, n) {
      var r = n(2);

      function o(e) {
        return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      }

      e.exports = function (e, t, n) {
        if (!t) return e;
        var i;
        if (n) i = n(t);else if (r.isURLSearchParams(t)) i = t.toString();else {
          var a = [];
          r.forEach(t, function (e, t) {
            null != e && (r.isArray(e) ? t += "[]" : e = [e], r.forEach(e, function (e) {
              r.isDate(e) ? e = e.toISOString() : r.isObject(e) && (e = JSON.stringify(e)), a.push(o(t) + "=" + o(e));
            }));
          }), i = a.join("&");
        }

        if (i) {
          var s = e.indexOf("#");
          -1 !== s && (e = e.slice(0, s)), e += (-1 === e.indexOf("?") ? "?" : "&") + i;
        }

        return e;
      };
    }, function (e, t, n) {
      e.exports = function (e) {
        return !(!e || !e.__CANCEL__);
      };
    }, function (e, t, n) {
      (function (t) {
        var r = n(2),
            o = n(28),
            i = {
          "Content-Type": "application/x-www-form-urlencoded"
        };

        function a(e, t) {
          !r.isUndefined(e) && r.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
        }

        var s,
            u = {
          adapter: (("undefined" != typeof XMLHttpRequest || void 0 !== t && "[object process]" === Object.prototype.toString.call(t)) && (s = n(15)), s),
          transformRequest: [function (e, t) {
            return o(t, "Accept"), o(t, "Content-Type"), r.isFormData(e) || r.isArrayBuffer(e) || r.isBuffer(e) || r.isStream(e) || r.isFile(e) || r.isBlob(e) ? e : r.isArrayBufferView(e) ? e.buffer : r.isURLSearchParams(e) ? (a(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : r.isObject(e) ? (a(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
          }],
          transformResponse: [function (e) {
            if ("string" == typeof e) try {
              e = JSON.parse(e);
            } catch (e) {}
            return e;
          }],
          timeout: 0,
          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",
          maxContentLength: -1,
          maxBodyLength: -1,
          validateStatus: function validateStatus(e) {
            return e >= 200 && e < 300;
          }
        };
        u.headers = {
          common: {
            Accept: "application/json, text/plain, */*"
          }
        }, r.forEach(["delete", "get", "head"], function (e) {
          u.headers[e] = {};
        }), r.forEach(["post", "put", "patch"], function (e) {
          u.headers[e] = r.merge(i);
        }), e.exports = u;
      }).call(this, n(27));
    }, function (e, t, n) {
      var r = n(2),
          o = n(29),
          i = n(31),
          a = n(12),
          s = n(32),
          u = n(35),
          c = n(36),
          f = n(16);

      e.exports = function (e) {
        return new Promise(function (t, n) {
          var l = e.data,
              d = e.headers;
          r.isFormData(l) && delete d["Content-Type"];
          var p = new XMLHttpRequest();

          if (e.auth) {
            var h = e.auth.username || "",
                v = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
            d.Authorization = "Basic " + btoa(h + ":" + v);
          }

          var m = s(e.baseURL, e.url);

          if (p.open(e.method.toUpperCase(), a(m, e.params, e.paramsSerializer), !0), p.timeout = e.timeout, p.onreadystatechange = function () {
            if (p && 4 === p.readyState && (0 !== p.status || p.responseURL && 0 === p.responseURL.indexOf("file:"))) {
              var r = "getAllResponseHeaders" in p ? u(p.getAllResponseHeaders()) : null,
                  i = {
                data: e.responseType && "text" !== e.responseType ? p.response : p.responseText,
                status: p.status,
                statusText: p.statusText,
                headers: r,
                config: e,
                request: p
              };
              o(t, n, i), p = null;
            }
          }, p.onabort = function () {
            p && (n(f("Request aborted", e, "ECONNABORTED", p)), p = null);
          }, p.onerror = function () {
            n(f("Network Error", e, null, p)), p = null;
          }, p.ontimeout = function () {
            var t = "timeout of " + e.timeout + "ms exceeded";
            e.timeoutErrorMessage && (t = e.timeoutErrorMessage), n(f(t, e, "ECONNABORTED", p)), p = null;
          }, r.isStandardBrowserEnv()) {
            var y = (e.withCredentials || c(m)) && e.xsrfCookieName ? i.read(e.xsrfCookieName) : void 0;
            y && (d[e.xsrfHeaderName] = y);
          }

          if ("setRequestHeader" in p && r.forEach(d, function (e, t) {
            void 0 === l && "content-type" === t.toLowerCase() ? delete d[t] : p.setRequestHeader(t, e);
          }), r.isUndefined(e.withCredentials) || (p.withCredentials = !!e.withCredentials), e.responseType) try {
            p.responseType = e.responseType;
          } catch (t) {
            if ("json" !== e.responseType) throw t;
          }
          "function" == typeof e.onDownloadProgress && p.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && p.upload && p.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
            p && (p.abort(), n(e), p = null);
          }), l || (l = null), p.send(l);
        });
      };
    }, function (e, t, n) {
      var r = n(30);

      e.exports = function (e, t, n, o, i) {
        var a = new Error(e);
        return r(a, t, n, o, i);
      };
    }, function (e, t, n) {
      var r = n(2);

      e.exports = function (e, t) {
        t = t || {};
        var n = {},
            o = ["url", "method", "data"],
            i = ["headers", "auth", "proxy", "params"],
            a = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
            s = ["validateStatus"];

        function u(e, t) {
          return r.isPlainObject(e) && r.isPlainObject(t) ? r.merge(e, t) : r.isPlainObject(t) ? r.merge({}, t) : r.isArray(t) ? t.slice() : t;
        }

        function c(o) {
          r.isUndefined(t[o]) ? r.isUndefined(e[o]) || (n[o] = u(void 0, e[o])) : n[o] = u(e[o], t[o]);
        }

        r.forEach(o, function (e) {
          r.isUndefined(t[e]) || (n[e] = u(void 0, t[e]));
        }), r.forEach(i, c), r.forEach(a, function (o) {
          r.isUndefined(t[o]) ? r.isUndefined(e[o]) || (n[o] = u(void 0, e[o])) : n[o] = u(void 0, t[o]);
        }), r.forEach(s, function (r) {
          r in t ? n[r] = u(e[r], t[r]) : r in e && (n[r] = u(void 0, e[r]));
        });
        var f = o.concat(i).concat(a).concat(s),
            l = Object.keys(e).concat(Object.keys(t)).filter(function (e) {
          return -1 === f.indexOf(e);
        });
        return r.forEach(l, c), n;
      };
    }, function (e, t, n) {
      function r(e) {
        this.message = e;
      }

      r.prototype.toString = function () {
        return "Cancel" + (this.message ? ": " + this.message : "");
      }, r.prototype.__CANCEL__ = !0, e.exports = r;
    }, function (e, t, n) {
      var r = n(20);
      n(9), n(5), n(10), n(1);
      t["default"] = r.a;
    }, function (e, t, n) {
      var r = n(1),
          o = n(5),
          i = n(0),
          _a = function a() {
        return (_a = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          s = function () {
        function e(e) {
          var t = this;
          this.lifeCycle = new r.a(), this.uploadJobQueue = [], this.additionalParams = {}, this.delayTime = 0, this._normalLogPipeline = Object(o.a)([function (e) {
            t.send({
              url: t.strategy.getUploadUrl(),
              data: e,
              method: "post",
              contentType: "application/json;charset=UTF-8"
            }, function () {
              var n = t.config.onReportSuccess;
              "function" == typeof n && n(JSON.stringify(e.events));
            }, function () {
              var n = t.config.onReportFail;
              "function" == typeof n && n(JSON.stringify(e.events));
            });
          }]), Object(r.b)(Boolean(e.appkey), "appkey must be initial"), this.config = _a({}, e);
        }

        return e.prototype.onUserAction = function (e, t) {
          this.preReport(e, t, !1);
        }, e.prototype.onDirectUserAction = function (e, t) {
          this.preReport(e, t, !0);
        }, e.prototype.preReport = function (e, t, n) {
          e ? this.strategy.isEventUpOnOff() && (this.strategy.isBlackEvent(e) || this.strategy.isSampleEvent(e) || this.onReport(e, t, n)) : this.errorReport.reportError("602", " no eventCode");
        }, e.prototype.addAdditionalParams = function (e) {
          for (var t = 0, n = Object.keys(e); t < n.length; t++) {
            var r = n[t];
            this.additionalParams[r] = e[r];
          }
        }, e.prototype.setChannelId = function (e) {
          this.commonInfo.channelID = String(e);
        }, e.prototype.setOpenId = function (e) {
          this.commonInfo.openid = String(e);
        }, e.prototype.setUnionid = function (e) {
          this.commonInfo.unid = String(e);
        }, e.prototype.getDeviceId = function () {
          return this.commonInfo.deviceId;
        }, e.prototype.getCommonInfo = function () {
          return this.commonInfo;
        }, e.prototype.removeSendingId = function (e) {
          var t = JSON.parse(this.storage.getItem(i.n)),
              n = t.indexOf(e);
          -1 != n && (t.splice(n, 1), this.storage.setItem(i.n, JSON.stringify(t)));
        }, e;
      }();

      t.a = s;
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || new Function("return this")();
      } catch (e) {
        "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
      }

      e.exports = n;
    }, function (e, t, n) {
      var r = n(2),
          o = n(11),
          i = n(23),
          a = n(17);

      function s(e) {
        var t = new i(e),
            n = o(i.prototype.request, t);
        return r.extend(n, i.prototype, t), r.extend(n, t), n;
      }

      var u = s(n(14));
      u.Axios = i, u.create = function (e) {
        return s(a(u.defaults, e));
      }, u.Cancel = n(18), u.CancelToken = n(37), u.isCancel = n(13), u.all = function (e) {
        return Promise.all(e);
      }, u.spread = n(38), u.isAxiosError = n(39), e.exports = u, e.exports["default"] = u;
    }, function (e, t, n) {
      var r = n(2),
          o = n(12),
          i = n(24),
          a = n(25),
          s = n(17);

      function u(e) {
        this.defaults = e, this.interceptors = {
          request: new i(),
          response: new i()
        };
      }

      u.prototype.request = function (e) {
        "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = s(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
        var t = [a, void 0],
            n = Promise.resolve(e);

        for (this.interceptors.request.forEach(function (e) {
          t.unshift(e.fulfilled, e.rejected);
        }), this.interceptors.response.forEach(function (e) {
          t.push(e.fulfilled, e.rejected);
        }); t.length;) {
          n = n.then(t.shift(), t.shift());
        }

        return n;
      }, u.prototype.getUri = function (e) {
        return e = s(this.defaults, e), o(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
      }, r.forEach(["delete", "get", "head", "options"], function (e) {
        u.prototype[e] = function (t, n) {
          return this.request(s(n || {}, {
            method: e,
            url: t,
            data: (n || {}).data
          }));
        };
      }), r.forEach(["post", "put", "patch"], function (e) {
        u.prototype[e] = function (t, n, r) {
          return this.request(s(r || {}, {
            method: e,
            url: t,
            data: n
          }));
        };
      }), e.exports = u;
    }, function (e, t, n) {
      var r = n(2);

      function o() {
        this.handlers = [];
      }

      o.prototype.use = function (e, t) {
        return this.handlers.push({
          fulfilled: e,
          rejected: t
        }), this.handlers.length - 1;
      }, o.prototype.eject = function (e) {
        this.handlers[e] && (this.handlers[e] = null);
      }, o.prototype.forEach = function (e) {
        r.forEach(this.handlers, function (t) {
          null !== t && e(t);
        });
      }, e.exports = o;
    }, function (e, t, n) {
      var r = n(2),
          o = n(26),
          i = n(13),
          a = n(14);

      function s(e) {
        e.cancelToken && e.cancelToken.throwIfRequested();
      }

      e.exports = function (e) {
        return s(e), e.headers = e.headers || {}, e.data = o(e.data, e.headers, e.transformRequest), e.headers = r.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), r.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
          delete e.headers[t];
        }), (e.adapter || a.adapter)(e).then(function (t) {
          return s(e), t.data = o(t.data, t.headers, e.transformResponse), t;
        }, function (t) {
          return i(t) || (s(e), t && t.response && (t.response.data = o(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
        });
      };
    }, function (e, t, n) {
      var r = n(2);

      e.exports = function (e, t, n) {
        return r.forEach(n, function (n) {
          e = n(e, t);
        }), e;
      };
    }, function (e, t) {
      var n,
          r,
          o = e.exports = {};

      function i() {
        throw new Error("setTimeout has not been defined");
      }

      function a() {
        throw new Error("clearTimeout has not been defined");
      }

      function s(e) {
        if (n === setTimeout) return setTimeout(e, 0);
        if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

        try {
          return n(e, 0);
        } catch (t) {
          try {
            return n.call(null, e, 0);
          } catch (t) {
            return n.call(this, e, 0);
          }
        }
      }

      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : i;
        } catch (e) {
          n = i;
        }

        try {
          r = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (e) {
          r = a;
        }
      }();
      var u,
          c = [],
          f = !1,
          l = -1;

      function d() {
        f && u && (f = !1, u.length ? c = u.concat(c) : l = -1, c.length && p());
      }

      function p() {
        if (!f) {
          var e = s(d);
          f = !0;

          for (var t = c.length; t;) {
            for (u = c, c = []; ++l < t;) {
              u && u[l].run();
            }

            l = -1, t = c.length;
          }

          u = null, f = !1, function (e) {
            if (r === clearTimeout) return clearTimeout(e);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

            try {
              r(e);
            } catch (t) {
              try {
                return r.call(null, e);
              } catch (t) {
                return r.call(this, e);
              }
            }
          }(e);
        }
      }

      function h(e, t) {
        this.fun = e, this.array = t;
      }

      function v() {}

      o.nextTick = function (e) {
        var t = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
          t[n - 1] = arguments[n];
        }
        c.push(new h(e, t)), 1 !== c.length || f || s(p);
      }, h.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = v, o.addListener = v, o.once = v, o.off = v, o.removeListener = v, o.removeAllListeners = v, o.emit = v, o.prependListener = v, o.prependOnceListener = v, o.listeners = function (e) {
        return [];
      }, o.binding = function (e) {
        throw new Error("process.binding is not supported");
      }, o.cwd = function () {
        return "/";
      }, o.chdir = function (e) {
        throw new Error("process.chdir is not supported");
      }, o.umask = function () {
        return 0;
      };
    }, function (e, t, n) {
      var r = n(2);

      e.exports = function (e, t) {
        r.forEach(e, function (n, r) {
          r !== t && r.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[r]);
        });
      };
    }, function (e, t, n) {
      var r = n(16);

      e.exports = function (e, t, n) {
        var o = n.config.validateStatus;
        n.status && o && !o(n.status) ? t(r("Request failed with status code " + n.status, n.config, null, n.request, n)) : e(n);
      };
    }, function (e, t, n) {
      e.exports = function (e, t, n, r, o) {
        return e.config = t, n && (e.code = n), e.request = r, e.response = o, e.isAxiosError = !0, e.toJSON = function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: this.config,
            code: this.code
          };
        }, e;
      };
    }, function (e, t, n) {
      var r = n(2);
      e.exports = r.isStandardBrowserEnv() ? {
        write: function write(e, t, n, o, i, a) {
          var s = [];
          s.push(e + "=" + encodeURIComponent(t)), r.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), r.isString(o) && s.push("path=" + o), r.isString(i) && s.push("domain=" + i), !0 === a && s.push("secure"), document.cookie = s.join("; ");
        },
        read: function read(e) {
          var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
          return t ? decodeURIComponent(t[3]) : null;
        },
        remove: function remove(e) {
          this.write(e, "", Date.now() - 864e5);
        }
      } : {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      };
    }, function (e, t, n) {
      var r = n(33),
          o = n(34);

      e.exports = function (e, t) {
        return e && !r(t) ? o(e, t) : t;
      };
    }, function (e, t, n) {
      e.exports = function (e) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
      };
    }, function (e, t, n) {
      e.exports = function (e, t) {
        return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
      };
    }, function (e, t, n) {
      var r = n(2),
          o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

      e.exports = function (e) {
        var t,
            n,
            i,
            a = {};
        return e ? (r.forEach(e.split("\n"), function (e) {
          if (i = e.indexOf(":"), t = r.trim(e.substr(0, i)).toLowerCase(), n = r.trim(e.substr(i + 1)), t) {
            if (a[t] && o.indexOf(t) >= 0) return;
            a[t] = "set-cookie" === t ? (a[t] ? a[t] : []).concat([n]) : a[t] ? a[t] + ", " + n : n;
          }
        }), a) : a;
      };
    }, function (e, t, n) {
      var r = n(2);
      e.exports = r.isStandardBrowserEnv() ? function () {
        var e,
            t = /(msie|trident)/i.test(navigator.userAgent),
            n = document.createElement("a");

        function o(e) {
          var r = e;
          return t && (n.setAttribute("href", r), r = n.href), n.setAttribute("href", r), {
            href: n.href,
            protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
            host: n.host,
            search: n.search ? n.search.replace(/^\?/, "") : "",
            hash: n.hash ? n.hash.replace(/^#/, "") : "",
            hostname: n.hostname,
            port: n.port,
            pathname: "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname
          };
        }

        return e = o(window.location.href), function (t) {
          var n = r.isString(t) ? o(t) : t;
          return n.protocol === e.protocol && n.host === e.host;
        };
      }() : function () {
        return !0;
      };
    }, function (e, t, n) {
      var r = n(18);

      function o(e) {
        if ("function" != typeof e) throw new TypeError("executor must be a function.");
        var t;
        this.promise = new Promise(function (e) {
          t = e;
        });
        var n = this;
        e(function (e) {
          n.reason || (n.reason = new r(e), t(n.reason));
        });
      }

      o.prototype.throwIfRequested = function () {
        if (this.reason) throw this.reason;
      }, o.source = function () {
        var e;
        return {
          token: new o(function (t) {
            e = t;
          }),
          cancel: e
        };
      }, e.exports = o;
    }, function (e, t, n) {
      e.exports = function (e) {
        return function (t) {
          return e.apply(null, t);
        };
      };
    }, function (e, t, n) {
      e.exports = function (e) {
        return "object" == _typeof(e) && !0 === e.isAxiosError;
      };
    }, function (e, t, n) {
      n.r(t), n.d(t, "WebOpts", function () {
        return I;
      });
      var r = n(19),
          o = n(6),
          i = n(8),
          a = n(0),
          s = n(1),
          u = n(7);
      var c = n(3),
          f = n.n(c);

      function l() {
        var e = navigator.userAgent,
            t = e.indexOf("compatible") > -1 && e.indexOf("MSIE") > -1,
            n = e.indexOf("Edge") > -1 && !t,
            r = e.indexOf("Trident") > -1 && e.indexOf("rv:11.0") > -1;

        if (t) {
          new RegExp("MSIE (\\d+\\.\\d+);").test(e);
          var o = parseFloat(RegExp.$1);
          return 7 == o ? 7 : 8 == o ? 8 : 9 == o ? 9 : 10 == o ? 10 : 6;
        }

        return n ? -2 : r ? 11 : -1;
      }

      var _d2,
          p = function p(e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function a(e) {
            try {
              u(r.next(e));
            } catch (e) {
              i(e);
            }
          }

          function s(e) {
            try {
              u(r["throw"](e));
            } catch (e) {
              i(e);
            }
          }

          function u(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }

          u((r = r.apply(e, t || [])).next());
        });
      },
          h = function h(e, t) {
        var n,
            r,
            o,
            i,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: s(0),
          "throw": s(1),
          "return": s(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function s(i) {
          return function (s) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (n = 1, r && (o = 2 & i[0] ? r["return"] : i[0] ? r["throw"] || ((o = r["return"]) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                  switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return a.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      a.label++, r = i[1], i = [0];
                      continue;

                    case 7:
                      i = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        a.label = i[1];
                        break;
                      }

                      if (6 === i[0] && a.label < o[1]) {
                        a.label = o[1], o = i;
                        break;
                      }

                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(i);
                        break;
                      }

                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  i = t.call(e, a);
                } catch (e) {
                  i = [6, e], r = 0;
                } finally {
                  n = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, s]);
          };
        }
      },
          v = function () {
        function e(e) {
          var t = l(),
              n = [];
          n = t > 8 && t < 10 ? [f.a.LOCALSTORAGE] : [f.a.INDEXEDDB, f.a.WEBSQL, f.a.LOCALSTORAGE], this.store = f.a.createInstance({
            driver: n,
            name: "Beacon" + e,
            version: 1,
            size: 2097152,
            storeName: "event_store_v2",
            description: "store beacon events"
          });
        }

        return e.prototype.insertEvent = function (e, t) {
          return p(this, void 0, void 0, function () {
            var n;
            return h(this, function (r) {
              switch (r.label) {
                case 0:
                  return n = Object(s.c)(e.mapValue), [4, this.store.setItem(n, e, t)];

                case 1:
                  return [2, r.sent()];
              }
            });
          });
        }, e.prototype.getEvents = function () {
          return p(this, void 0, void 0, function () {
            var e;
            return h(this, function (t) {
              switch (t.label) {
                case 0:
                  e = [], t.label = 1;

                case 1:
                  return t.trys.push([1, 3,, 4]), [4, this.store.iterate(function (t) {
                    e.push(t);
                  })];

                case 2:
                  return t.sent(), [2, Promise.all(e)];

                case 3:
                  return t.sent(), [2, Promise.all(e)];

                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.removeEvent = function (e) {
          return p(this, void 0, void 0, function () {
            var t;
            return h(this, function (n) {
              switch (n.label) {
                case 0:
                  return t = Object(s.c)(e.mapValue), [4, this.store.removeItem(t)];

                case 1:
                  return n.sent(), [2];
              }
            });
          });
        }, e;
      }(),
          m = n(4),
          y = n.n(m),
          _g = function g() {
        return (_g = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          b = function () {
        function e(e) {
          y.a.interceptors.request.use(this.getRequestInteceptor(e));
        }

        return e.prototype.get = function (e, t) {
          return y.a.get(e, t);
        }, e.prototype.post = function (e, t, n) {
          return y.a.post(e, t, n);
        }, e.prototype.isCancel = function (e) {
          return y.a.isCancel(e);
        }, e.prototype.getRequestInteceptor = function (e) {
          return function (t) {
            var n = t.url,
                r = t.method,
                o = t.data,
                i = o,
                a = !1;

            if (e.onReportBeforeSend) {
              var s = e.onReportBeforeSend({
                url: n,
                method: r,
                data: o
              });
              a = !(i = (null == s ? void 0 : s.data) || null);
            }

            return _g(_g({}, t), {
              data: i,
              cancelToken: a ? new y.a.CancelToken(function (e) {
                return e("No data for sdk, cancel.");
              }) : void 0
            });
          };
        }, e;
      }(),
          w = function () {
        function e(e) {
          this.appkey = e;
        }

        return e.prototype.getItem = function (e) {
          try {
            return window.localStorage.getItem(this.getStoreKey(e));
          } catch (e) {
            return "";
          }
        }, e.prototype.removeItem = function (e) {
          try {
            window.localStorage.removeItem(this.getStoreKey(e));
          } catch (e) {}
        }, e.prototype.setItem = function (e, t) {
          try {
            window.localStorage.setItem(this.getStoreKey(e), t);
          } catch (e) {}
        }, e.prototype.setSessionItem = function (e, t) {
          try {
            window.sessionStorage.setItem(this.getStoreKey(e), t);
          } catch (e) {}
        }, e.prototype.getSessionItem = function (e) {
          try {
            return window.sessionStorage.getItem(this.getStoreKey(e));
          } catch (e) {
            return "";
          }
        }, e.prototype.getStoreKey = function (e) {
          return a.o + this.appkey + "_" + e;
        }, e.prototype.createDeviceId = function () {
          var e = window.localStorage.getItem(a.g);
          return e || (e = function (e) {
            for (var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789", n = "", r = 0; r < e; r++) {
              n += t.charAt(Math.floor(Math.random() * t.length));
            }

            return n;
          }(32), window.localStorage.setItem(a.g, e)), e;
        }, e;
      }(),
          _ = (_d2 = function d(e, t) {
        return (_d2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) {
            t.hasOwnProperty(n) && (e[n] = t[n]);
          }
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _d2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      }),
          _S = function S() {
        return (_S = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        }).apply(this, arguments);
      },
          I = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return _(t, e), t;
      }(u.a),
          E = function (e) {
        function t(t) {
          var n = e.call(this, t) || this;

          n.send = function (e, t, r) {
            n.storage.setItem(a.k, Date.now().toString()), n.network.post(n.strategy.getUploadUrl(), e.data).then(function (r) {
              100 == r.data.result ? n.delayTime = 1e3 * r.data.delayTime : n.delayTime = 0, t && t(e.data), e.data.events.forEach(function (e) {
                n.store.removeEvent(e).then(function () {
                  n.removeSendingId(Object(s.c)(e.mapValue));
                });
              });
            })["catch"](function (t) {
              var o = e.data.events;
              n.errorReport.reportError(t.code ? t.code.toString() : "600", t.message), r && r(e.data), o.forEach(function (e) {
                n.store.insertEvent(e, function (e, t) {
                  e && n.errorReport.reportError("604", "insertEvent fail!"), n.removeSendingId(Object(s.c)(t.mapValue));
                });
              });
            });
          };

          var r = l();
          return n.isUnderIE8 = r > 0 && r < 8, n.isUnderIE8 || (n.network = new b(t), n.storage = new w(t.appkey), n.initCommonInfo(t), n.initSession(t), n.store = new v(t.appkey), n.errorReport = new o.a(n.config, n.commonInfo, "web", n.network), n.strategy = new i.a(n.config, n.commonInfo, n.storage, n.network), n.onDirectUserAction("rqd_js_init", {}), setTimeout(function () {
            return n.lifeCycle.emit("init");
          }, 0), n.initDelayTime = t.delay ? t.delay : 1e3, n.cycleTask(n.initDelayTime)), n;
        }

        return _(t, e), t.prototype.initSession = function (e) {
          var t,
              n,
              r,
              o = 18e5;
          e.sessionDuration && e.sessionDuration > 3e4 && (o = e.sessionDuration), this.getSession = (t = this.storage, n = o, r = this, function (e) {
            var o = Date.now();

            function i() {
              var n = {
                sessionId: e + "_" + o.toString(),
                sessionStart: o
              };
              t.setItem("session_storage_key", JSON.stringify(n)), t.setItem(a.k, Date.now().toString());
              var i = t.getItem("is_new_user");
              return r.onDirectUserAction("rqd_applaunched", {
                A21: i ? "N" : "Y"
              }), t.setItem("is_new_user", JSON.stringify(!1)), n;
            }

            var s = Promise.resolve(t.getItem("session_storage_key"));
            return s.then(function (e) {
              if (!e) return Promise.resolve(i());
              var r = JSON.parse(e) || {
                sessionId: void 0,
                sessionStart: void 0
              };
              if (!r.sessionId || !r.sessionStart) return Promise.resolve(i());
              var s = Number(t.getItem(a.k));
              return o - s > n ? Promise.resolve(i()) : Promise.resolve({
                sessionId: r.sessionId,
                sessionStart: r.sessionStart
              });
            });
          }), this.session$ = this.getSession(e.appkey);
        }, t.prototype.initCommonInfo = function (e) {
          var t = Number(this.storage.getItem(a.k)),
              n = JSON.parse(this.storage.getItem(a.n));
          (Date.now() - t > 3e4 || !n) && this.storage.setItem(a.n, JSON.stringify([]));
          var r = [window.screen.width, window.screen.height];
          window.devicePixelRatio && r.push(window.devicePixelRatio), this.commonInfo = {
            deviceId: this.storage.createDeviceId(),
            language: navigator && navigator.language || "zh_CN",
            query: window.location.search,
            userAgent: navigator.userAgent,
            pixel: r.join("*"),
            channelID: e.channelID ? String(e.channelID) : "",
            openid: e.openid ? String(e.openid) : "",
            unid: e.unionid ? String(e.unionid) : "",
            sdkVersion: "4.2.7-web"
          }, this.config.appVersion = e.versionCode ? String(e.versionCode) : "", this.config.strictMode = e.strictMode;
        }, t.prototype.cycleTask = function (e) {
          var t = this;
          setTimeout(function () {
            t.store.getEvents().then(function (e) {
              var n = [],
                  r = JSON.parse(t.storage.getItem(a.n));
              r || (r = []), e && e.forEach(function (e) {
                var t = Object(s.c)(e.mapValue);
                -1 == r.indexOf(t) && (n.push(e), r.push(t));
              }), 0 != n.length && (t.storage.setItem(a.n, JSON.stringify(r)), t.assembleData(n));
            }), t.cycleTask(0 == t.delayTime ? t.initDelayTime : t.delayTime);
          }, e);
        }, t.prototype.onReport = function (e, t, n) {
          var r = this;
          if (this.isUnderIE8) this.errorReport.reportError("601", "UnderIE8");else {
            var o = [],
                i = "4.2.7-web_" + (n ? a.h : a.m),
                u = Number(this.storage.getItem(i));
            if (u = u || 1, t = _S(_S({}, t), {
              A99: n ? "Y" : "N",
              A100: String(u),
              A72: "4.2.7-web"
            }), u++, this.storage.setItem(i, String(u)), o.push({
              eventCode: e,
              eventTime: Date.now().toString(),
              mapValue: Object(s.d)(t, this.config.strictMode)
            }), n && 0 == this.delayTime) this.assembleData(o);else {
              var c = o.shift();
              c && this.store.insertEvent(c, function (e) {
                e && r.errorReport.reportError("604", "insertEvent fail!");
              });
            }
          }
        }, t.prototype.assembleData = function (e) {
          var t = this;
          this.session$ = this.getSession(this.config.appkey), this.session$ && this.session$.then(function (n) {
            var r = {
              appVersion: t.config.appVersion ? Object(s.e)(t.config.appVersion) : "",
              sdkId: "js",
              sdkVersion: "4.2.7-web",
              mainAppKey: t.config.appkey,
              platformId: 3,
              common: Object(s.d)(_S(_S({}, t.additionalParams), {
                A2: t.commonInfo.deviceId,
                A8: t.commonInfo.openid,
                A12: t.commonInfo.language,
                A17: t.commonInfo.pixel,
                A23: t.commonInfo.channelID,
                A50: t.commonInfo.unid,
                A76: n.sessionId,
                A101: t.commonInfo.userAgent,
                A102: window.location.href,
                A104: document.referrer,
                A119: t.commonInfo.query
              }), !1),
              events: e
            };

            t._normalLogPipeline(r);
          });
        }, t;
      }(r["default"]);

      t["default"] = E;
    }])["default"];
  });
});
var BeaconAction = unwrapExports(beacon_web_min);
beacon_web_min.BeaconAction;
var uaInspector_min = createCommonjsModule(function (module, exports) {
  /*
   * UA Inspector v1.1.0
   * (c) 2021 lincao <lincao@tencent.com>
   */
  !function (e, r) {
    module.exports = r();
  }(commonjsGlobal, function () {
    function e(e, r) {
      for (var t = 0; t < r.length; t++) {
        var n = r[t];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function r(e, r, t) {
      return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }

    var t = /\d+([._]\d+)*/;

    function n(e) {
      var r,
          n = t.exec(e);
      return null != (r = null == n ? void 0 : n[0].replace(/_/g, ".")) ? r : null;
    }

    function i(e) {
      var r = n(e);
      return (null == r ? void 0 : r.split(".").map(Number)) || [];
    }

    function o(e, r) {
      return void 0 === r && (r = ""), "" === r || (t = i(e), n = i(r), (o = Array(Math.max(t.length, n.length)).fill(0).map(function (e, r) {
        return (t[r] || 0) - (n[r] || 0);
      }).find(function (e) {
        return 0 !== e;
      }) || 0) < 0 ? -1 : o > 0 ? 1 : 0);
      var t, n, o;
    }

    function s(e, r) {
      var t;

      try {
        t = new RegExp("\\b" + e + "\\W+\\d+([\\._]\\d+)*", "i");
      } catch (e) {
        return null;
      }

      var i = t.exec(r);
      return i ? n(i[0].substring(e.length)) : null;
    }

    var u = {
      qq: /QQBrowser/,
      maxthon: /Maxthon/,
      taobao: /TaoBrowser/,
      baidu: /BIDUBrowser/,
      uc: /UBrowser/,
      chrome: /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i
    };

    var a = function () {
      function t(e) {
        var t = this;
        r(this, "getQQBrowserVersion", function () {
          return t.isPCQQBrowser ? s("QQBrowser", t.userAgent) : null;
        }), r(this, "isQQBrowserVersionAboveOrEqual", function (e) {
          return o(t.getQQBrowserVersion() || "", e) >= 0;
        }), r(this, "getChromeVersion", function () {
          return s("Chrome", t.userAgent);
        }), r(this, "isChromeVersionAboveOrEqual", function (e) {
          return o(t.getChromeVersion() || "", e) >= 0;
        }), r(this, "getSafariVersion", function () {
          return s("Safari", t.userAgent);
        });
        var n = "";
        void 0 === e && (n = "undefined" != typeof navigator ? navigator.userAgent : ""), Object.defineProperty(this, "userAgent", {
          value: n,
          writable: !1
        });
      }

      var n,
          i,
          f = t.prototype;
      return f.getIEShellType = function () {
        return /SE/.test(this.userAgent) ? "sougouIE" : /QQBrowser/.test(this.userAgent) ? "qqIE" : "ie";
      }, f.getIEVersion = function () {
        var e = /(msie\s|trident.*rv:)([\w.]+)/.exec(this.userAgent.toLowerCase());

        try {
          return e[2];
        } catch (e) {
          return document.documentMode || "";
        }
      }, f.getEdgeVersion = function () {
        return s("Edge", this.userAgent);
      }, f.getFirefoxVersion = function () {
        return s("Firefox", this.userAgent);
      }, f.getChromiumShellType = function () {
        var e = function () {
          if (void 0 !== window.scrollMaxX) return "";
          var e = window.navigator.appVersion,
              r = window.external;
          if (r && "SEVersion" in r) return "sougou";
          if (r && "LiebaoGetVersion" in r) return "liebao";
          var t = Object.values(u).findIndex(function (r) {
            return r.test(e);
          });
          return -1 !== t ? Object.keys(u)[t] : /\sOPR\//.test(e) || /Opera/.test(e) || window.navigator.vendor && 0 === window.navigator.vendor.indexOf("Opera") ? "opera" : "";
        }();

        return ["maxthon", "opera"].includes(e) ? e : "" !== e ? e + "Chrome" : "";
      }, n = t, (i = [{
        key: "isMobile",
        get: function get() {
          return /(mobile)/i.test(this.userAgent);
        }
      }, {
        key: "isPCQQBrowser",
        get: function get() {
          return !this.isMobile && /QQBrowser/i.test(this.userAgent) && !/QBCore/i.test(this.userAgent);
        }
      }, {
        key: "isChrome",
        get: function get() {
          return /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i.test(this.userAgent);
        }
      }, {
        key: "isSafari",
        get: function get() {
          return /Version\/\S+( Mobile\S*)? Safari\/\S+$/i.test(this.userAgent);
        }
      }, {
        key: "isIE",
        get: function get() {
          return /MSIE/i.test(this.userAgent) && !/opera/i.test(this.userAgent) || /Trident/i.test(this.userAgent);
        }
      }, {
        key: "isOldEdge",
        get: function get() {
          return /Edge/i.test(this.userAgent);
        }
      }, {
        key: "isChromiumEdge",
        get: function get() {
          return /Edg\//i.test(this.userAgent);
        }
      }, {
        key: "isFirefox",
        get: function get() {
          return /(Firefox|Focus|FxiOS)\//i.test(this.userAgent);
        }
      }, {
        key: "isChromiumShell",
        get: function get() {}
      }, {
        key: "isXHH",
        get: function get() {
          return -1 !== this.userAgent.indexOf("Macintosh; Intel Mac OS X 10_12_6") && -1 !== this.userAgent.indexOf("Chrome/75.0.3770.100");
        }
      }]) && e(n.prototype, i), t;
    }();

    return new a(), function () {
      function e(r) {
        return e.instance || (e.instance = this), this.UAInstance = new a(r), e.instance;
      }

      var r = e.prototype;
      return r.getBrowserInfo = function () {
        var e = "",
            r = "",
            t = this.UAInstance;
        t.isSafari ? (e = "safari", r = t.getSafariVersion()) : t.isIE ? (e = t.getIEShellType(), r = t.getIEVersion()) : t.isOldEdge ? (e = "edgeOld", r = t.getEdgeVersion()) : t.isChromiumEdge ? (e = "edgeChrome", r = t.getChromeVersion()) : t.isFirefox ? (e = "firefox", r = t.getFirefoxVersion()) : t.isChrome ? t.isXHH ? (e = "xhh", r = "75") : (e = "chrome", r = t.getChromeVersion()) : t.isPCQQBrowser ? (e = "qqChrome", r = t.getQQBrowserVersion()) : (e = t.getChromiumShellType(), r = t.getChromeVersion());

        var n = function () {
          var e = "",
              r = navigator.userAgent.toLowerCase();
          return r.indexOf("win") > -1 ? (e = "win", /(win64|wow64|win32|wow32|windows nt)/.test(r) && (-1 !== RegExp.$1.indexOf("windows nt") ? -1 != r.indexOf("windows nt 5") ? e += "xp" : -1 != r.indexOf("windows nt 7") ? e += "7" : -1 != r.indexOf("windows nt 10") && (e += "10") : e += "-" + RegExp.$1)) : /Mac OS X/.test(r) > -1 ? e = "mac" : r.indexOf("linux") > -1 && (e = "linux"), e;
        }(),
            i = navigator.platform.toLowerCase();

        return {
          browser: {
            name: e,
            version: r
          },
          system: n,
          isMobile: t.isMobile,
          platform: i,
          fullname: n + "--" + i + "--" + e
        };
      }, r.check = function (e) {
        void 0 === e && (e = []);
        var r = this.getBrowserInfo(),
            t = r.browser,
            n = r.isMobile,
            i = t.name;
        return !n && "" !== i && (0 === e.length || !!e.includes(i));
      }, e;
    }();
  });
});

var DTReport = /*#__PURE__*/function () {
  function DTReport(config) {
    _classCallCheck(this, DTReport);

    this.enable = false;
    this.debug = false;
    this.consolelog = true;
    this.beaconInstant = null;
    this.init(config);
  }

  _createClass(DTReport, [{
    key: "init",
    value: function init(_ref3) {
      var appkey = _ref3.appkey,
          _ref3$delay = _ref3.delay,
          delay = _ref3$delay === void 0 ? 1000 : _ref3$delay,
          _ref3$debug = _ref3.debug,
          debug = _ref3$debug === void 0 ? false : _ref3$debug,
          _ref3$consolelog = _ref3.consolelog,
          consolelog = _ref3$consolelog === void 0 ? true : _ref3$consolelog,
          _onReportSuccess = _ref3.onReportSuccess,
          enableReport = _ref3.enableReport,
          _onReportFail = _ref3.onReportFail,
          _ref3$commonParams = _ref3.commonParams,
          commonParams = _ref3$commonParams === void 0 ? {} : _ref3$commonParams,
          useBeaconSDK = _ref3.useBeaconSDK,
          keyEid = _ref3.keyEid;

      if (this.beaconInstant !== null) {
        return;
      }

      this.enable = typeof enableReport === 'function' ? enableReport() : true;
      this.debug = debug;
      this.consolelog = consolelog;
      this.keyEid = keyEid || defaultEid; // 灯塔sdk初始化

      this.beaconInstant = new BeaconAction({
        // startDebug开启实时联调查看地址：http://datahub.tencent.com/common/view_debug
        appkey: debug ? '0M000A1RC72MXXRH' : appkey,
        delay: delay,
        // 普通事件 延迟上报时间
        onReportSuccess: function onReportSuccess() {
          _onReportSuccess && _onReportSuccess();
        },
        // 上报成功回调,选填
        onReportFail: function onReportFail(e) {
          // 上报失败回调,选填
          _onReportFail && _onReportFail(e);
        }
      });

      if (typeof useBeaconSDK === 'function') {
        useBeaconSDK(this.beaconInstant);
      }

      var webid = this.beaconInstant.getDeviceId();
      var ua = new uaInspector_min();

      var _ua$getBrowserInfo = ua.getBrowserInfo(),
          _ua$getBrowserInfo$fu = _ua$getBrowserInfo.fullname,
          fullname = _ua$getBrowserInfo$fu === void 0 ? '' : _ua$getBrowserInfo$fu; // 追加设置公共参数


      this.beaconInstant.addAdditionalParams(_objectSpread({
        user_key: webid,
        browser: navigator.userAgent,
        realua: fullname
      }, commonParams)); // call beaconSDK

      typeof useBeaconSDK === 'function' && useBeaconSDK(this.beaconInstant);
    }
  }, {
    key: "report",
    value: function report(type, params) {
      var isDirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var reportFuncName = isDirect ? 'onDirectUserAction' : 'onUserAction';

      if (!this.beaconInstant) {
        console.log('please init dtreport instant before do report');
        return false;
      }

      if (this.consolelog) {
        console.log('dtreport debug', type, params);
      }

      if (!this.enable) {
        return false;
      }

      var reportparams = null;

      if (isHTMLElement(params)) {
        // 声明式上报的dom节点，event.target需要声明dt-eid属性
        var eid = getTargetAttr(params, this.keyEid);
        var remark = getTargetAttr(params, 'dt-remark');

        if (eid !== null) {
          reportparams = {
            eid: eid,
            remark: remark
          };
        } else {
          console.warn('to use reportclick, need to add dt-eid attribute to your clicked dom');
        }
      } else {
        // 自定义上报，直接传入上报参数
        reportparams = params;
      }

      if (reportparams) {
        this.beaconInstant["".concat(reportFuncName)](type, _objectSpread(_objectSpread({}, window.DTReportRouterinfo || {}), reportparams));
      }
    }
  }]);

  return DTReport;
}();

var DT_REPORT_FILTER$2 = {
  classSuffix: '-cls',
  // 被认定为点击事件的class，不需要完整，只要包含就算
  click: ['omui-radio', 'omui-input', 'omui-checkbox', 'omui-dropdown', 'omui-tab__label', 'omui-textarea', 'omui-datepicker', 'omui-timepicker', 'omui-thumb', 'omui-select', 'omui-swiper', 'omui-suggestion', 'omui-upload'],
  // 需要上报区域曝光选择器，find为如何识别该区域，会将其特征用作areaid参数，不设置find则以key代表的dom特征作为areaid
  area: ['.omui-panel', '.omui-tab__panel', '[dt-areaid]', '.omui-form__group', '.omui-table-table'],
  dialogSelector: '.omui-dialog',
  formSelector: ['.omui-form__group', '.omui-filter__group'],
  tableSelector: '.omui-table-table',
  tabSelector: '.omui-tab__panel',
  find: {
    '.omui-panel': '.omui-panel__title',
    '.omui-form__group': '.omui-form__label',
    '.omui-filter__group': '.omui-filter__label'
  }
};
var DT_REPORT_FILTER$1 = {
  classSuffix: '',
  // 被认定为点击事件的class，不需要完整，只要包含就算
  click: ['ant-menu', 'ant-input', 'ant-btn', 'ant-checkbox', 'ant-cascader', 'ant-picker-input', 'ant-radio', 'ant-select', 'ant-switch', 'ant-upload', 'ant-tabs-tab'],
  area: ['.ant-card', '.ant-list', '.ant-tabs-tabpane', '.ant-form-item', '[dt-areaid]'],
  dialogSelector: ['.ant-modal-content', '.ant-notification', '.ant-drawer-content'],
  formSelector: '.ant-form-item',
  tableSelector: '.ant-table',
  tabSelector: '.ant-tabs',
  find: {
    '.ant-card': '.ant-card-head-title',
    '.ant-list': '.ant-list-header',
    '.ant-modal-content': '.ant-modal-title',
    '.ant-drawer-content': '.ant-drawer-title',
    '.ant-tabs': '.ant-tabs-tab-active .ant-tabs-tab-btn',
    '.ant-form-item': '.ant-form-item-label label'
  }
};
var DT_REPORT_FILTER = {
  classSuffix: '-',
  // 被认定为点击事件的class，不需要完整，只要包含就算
  click: ['el-radio', 'el-input', 'el-checkbox', 'el-input-number', 'el-cascader', 'el-dropdown', 'el-tabs__item', 'el-textarea', 'el-date-picker', 'el-switch', 'el-time-spinner__item', 'el-select', 'el-slider__button', 'el-upload', 'el-link'],
  // 需要上报区域曝光选择器，find为如何识别该区域，会将其特征用作areaid参数，不设置find则以key代表的dom特征作为areaid
  area: ['[dt-areaid]', '.el-tabs', '.el-table', '.el-form'],
  dialogSelector: '.el-dialog',
  formSelector: ['.el-form'],
  tableSelector: '.el-table',
  tabSelector: '.el-tabs__content',
  find: {
    '.el-tabs': '.el-tabs__item',
    '.el-form': '.el-form-item__label'
  }
};
var defaultConf = {
  omui: DT_REPORT_FILTER$2,
  antd: DT_REPORT_FILTER$1,
  element: DT_REPORT_FILTER
};
var supportedLib = ['antd', 'element'];

var AutoTrack = /*#__PURE__*/function () {
  function AutoTrack(opt) {
    var _this4 = this;

    _classCallCheck(this, AutoTrack);

    _defineProperty(this, "setDefaultConfig", function (uselib, track) {
      if (supportedLib.includes(uselib)) {
        var _defaultConf$uselib = defaultConf[uselib],
            click = _defaultConf$uselib.click,
            temparea = _defaultConf$uselib.area,
            tempfind = _defaultConf$uselib.find,
            rest = _objectWithoutProperties(_defaultConf$uselib, _excluded);

        _this4.trackConfig = _objectSpread(_objectSpread(_objectSpread({}, rest), _this4.trackConfig), {}, {
          click: click.concat(track && track.click || []),
          area: temparea.concat(track && track.area || []),
          find: Object.assign({}, tempfind, track && track.find || {})
        });
      } // set keyEid


      _this4.trackConfig.keyEid = track.keyEid || defaultEid;
    });

    _defineProperty(this, "handleInitReport", function (report) {
      var param = _objectSpread(_objectSpread({}, report), {}, {
        keyEid: _this4.trackConfig.keyEid
      });

      var DTReport$1 = new DTReport(param);

      var reportBeacon = function reportBeacon(type, params) {
        var isDirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        DTReport$1.report(type, _objectSpread({}, params), isDirect);
      };

      _this4.reportBeacon = reportBeacon;
      window.DTReport = reportBeacon;
      window.OMdtReport = reportBeacon;
    });

    _defineProperty(this, "handleInspector", function (openInspector) {
      var inspector;

      if (openInspector()) {
        // 满足条件开启埋点坑位探查
        inspector = new DomInspector({
          maxZIndex: 999999,
          trackConfig: _this4.trackConfig,
          useTrackClickDomHasEvent: true
        });
        inspector.enable();
      }
    });

    _defineProperty(this, "handleExposure", function () {
      var _this4$trackConfig = _this4.trackConfig,
          area = _this4$trackConfig.area,
          _this4$trackConfig$cl = _this4$trackConfig.classSuffix,
          classSuffix = _this4$trackConfig$cl === void 0 ? '-cls' : _this4$trackConfig$cl,
          find = _this4$trackConfig.find;
      _this4.ExposureInstant = new Exposure({
        config: {
          area: area,
          find: find,
          classSuffix: classSuffix
        },
        doReport: function doReport(params) {
          return _this4.reportBeacon('show_area', params);
        }
      });
    });

    _defineProperty(this, "handleEventListener", function () {
      document.addEventListener('mousedown', _this4.onDocumentClick, false); // 页面可见回调，当页面不可见时，减少页面曝光时间统计

      var _getVisibleEventAttr = getVisibleEventAttr(),
          visibilityChange = _getVisibleEventAttr.visibilityChange;

      document.addEventListener(visibilityChange, _this4.onVisibilityChange, false);
      window.addEventListener('beforeunload', _this4.leaving);
    });

    _defineProperty(this, "reportShowPage", function (_ref4) {
      var path = _ref4.path,
          _ref4$query = _ref4.query,
          query = _ref4$query === void 0 ? {} : _ref4$query,
          search = _ref4.search;
      var area = _this4.trackConfig.area;
      var list = query; // 如果是 search ，需要做一下 parse

      if (search) {
        list = queryString.parse(search);
      } // 将路径所带的query转化为{ qr_${query}:xxxx } 的结构


      var queryList = Object.keys(list).reduce(function (result, q) {
        result["qr_".concat(q.toLowerCase())] = list[q];
        return result;
      }, {});
      var _location = location,
          localPath = _location.pathname,
          hash = _location.hash;

      var routeinfo = _objectSpread({
        // sdk 已上报，兼容旧项目
        url: window.location.href,
        pathname: path,
        query: queryString.stringify(list),
        // 兼容旧项目
        path: localPath + hash.split('?')[0]
      }, queryList); // 页面曝光


      var pagefrom = _this4.prevRouteRef.from || '' || (_this4.prevRouteRef.pathname || '') + (_this4.prevRouteRef.query || '');

      _this4.reportBeacon('show_page', _objectSpread(_objectSpread({}, routeinfo), {}, {
        pagefrom: pagefrom // 页面进入来源

      })); // 页面停留时长


      var now = new Date(); // 进入页面时间

      _this4.handleStayPage(now); // 页面区域可见


      if (area.length > 0) {
        var areaSelector = area.join(',');
        setTimeout(function () {
          var sectionArea = document.querySelectorAll(areaSelector);

          if (sectionArea.length > 0) {
            sectionArea.forEach(function (el, index) {
              el && _this4.ExposureInstant.add(el, index);
            });
          }
        }, 3000);
      }

      _this4.pageEnterTime = now;
      _this4.prevRouteRef = routeinfo;
      window.DTReportRouterinfo = _objectSpread(_objectSpread({}, routeinfo), {}, {
        pagefrom: pagefrom
      });
    });

    _defineProperty(this, "handleRouterListener", function (router) {
      if (router) {
        router.afterEach(function (to) {
          // !: 需要异步等一下，不然 href 会是上一个页面的
          setTimeout(function () {
            _this4.reportShowPage(to);
          });
        });
      }
    });

    _defineProperty(this, "handleHistoryListener", function (history) {
      if (history) {
        history.listen(function (location) {
          var pathname = location.pathname,
              search = location.search;

          _this4.reportShowPage({
            path: pathname,
            search: search
          });
        });
      }
    });

    _defineProperty(this, "handleEnterPageReport", function () {
      if (_this4.enterpageReport) {
        _this4.reportShowPage({
          path: window.location.pathname,
          search: window.location.search
        }); // 需要单独上报页面进入pv

      }
    });

    _defineProperty(this, "leaving", function () {
      document.removeEventListener('mousedown', _this4.onDocumentClick, false);
      document.removeEventListener('visibilityChange', _this4.onVisibilityChange, false);

      _this4.handleStayPage();
    });

    _defineProperty(this, "onVisibilityChange", function () {
      var _getVisibleEventAttr2 = getVisibleEventAttr(),
          hidden = _getVisibleEventAttr2.hidden;

      var now = Date.now();

      if (document[hidden]) {
        _this4.pageHiddenTime += now - _this4.pageEnterTime; // 不可见期间的用时
      }

      _this4.pageEnterTime = now;
    });

    _defineProperty(this, "onDocumentClick", function (event) {
      var $target = event.target;
      var eventType = 'click';
      var params = trackClickDomHasEvent($target, _this4.trackConfig);

      if (params) {
        _this4.reportBeacon(eventType, _objectSpread(_objectSpread({}, _this4.prevRouteRef), params));
      }
    });

    if (!AutoTrack.instance) {
      // 参数设置
      var track = opt.track,
          enterpageReport = opt.enterpageReport; // 保存一些长期值

      this.prevRouteRef = {
        from: document.referrer && document.referrer.split('.com')[1] || ''
      };
      this.pageEnterTime = 0;
      this.pageHiddenTime = 0;
      this.trackConfig = track;
      this.maxTry = 2;
      this.enterpageReport = enterpageReport; // 将this挂载到 AutoTrack 这个类的instance属性上

      AutoTrack.instance = this;
      this.init(opt);
    }

    return AutoTrack.instance;
  }

  _createClass(AutoTrack, [{
    key: "init",
    value: function init(opt) {
      var router = opt.router,
          history = opt.history,
          report = opt.report,
          track = opt.track,
          _opt$uselib = opt.uselib,
          uselib = _opt$uselib === void 0 ? '' : _opt$uselib,
          _opt$openInspector = opt.openInspector,
          openInspector = _opt$openInspector === void 0 ? function () {
        return true;
      } : _opt$openInspector,
          _opt$enterpageReport = opt.enterpageReport,
          enterpageReport = _opt$enterpageReport === void 0 ? true : _opt$enterpageReport;
      this.setDefaultConfig(uselib, track);
      this.handleInitReport(report);
      this.handleInspector(openInspector);
      this.handleExposure();
      this.handleRouterListener(router);
      this.handleHistoryListener(history);
      this.handleEnterPageReport(enterpageReport);
      this.handleEventListener();
    } // default 设置

  }, {
    key: "handleStayPage",
    value: function handleStayPage() {
      var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

      if (this.pageEnterTime !== 0) {
        this.reportBeacon('stay_page', _objectSpread(_objectSpread({}, this.prevRouteRef), {}, {
          staytime: now - this.pageEnterTime + this.pageHiddenTime
        }));
      }
    }
  }]);

  return AutoTrack;
}();

export { AutoTrack };
//# sourceMappingURL=index.es.js.map
